import React, { useEffect, useState } from "react";
import { Accordion, AccordionSummary, AccordionDetails, Box, Typography, Button, Checkbox, Slider, FormControlLabel, RadioGroup, FormControl, Grid, Radio, Chip, Dialog, DialogTitle, DialogContent, TextField, DialogActions
} from "@mui/material";
import { getData, postData } from "../../../ServerRequest";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import LandscapeIcon from "@mui/icons-material/Landscape";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
//import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
//import CancelIcon from "@mui/icons-material/Cancel";

// Helper: check if string is a valid hex color
const isHexColor = (str) => /^#([0-9A-F]{3}){1,2}$/i.test(str);

// Helper: check if string is a valid CSS color name
const isValidCssColor = (str) => {
  if (!str) return false;
  const s = new Option().style;
  s.color = str;
  return s.color !== '';
};

// Helper: get display color or fallback
const getDisplayColor = (colorStr) => {
  if (isHexColor(colorStr) || isValidCssColor(colorStr)) {
    return colorStr;
  }
  return "#ccc"; // fallback color
};

export default function AddFabricTag({ onTagsSaved }) {
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({});
  const [fabricCategories, setFabricCategories] = useState([]);
  const [fabricTags, setFabricTags] = useState({
    "Fabric Category": [],
    "Blends": [],
    "Character": [],
    "Weave": [],
    "Structure": [],
    "Yarn property": [],
    "Fabric Finish": [],
    "Season": [],
    "Category": [],
    "Style": [],
    "Denim": [],
    "Sustainability": [],
    "Dye technique": [],
    "Dye used": [],
    "Pattern size": [],
    "Print style": [],
    "Pattern": [],
    "Base color": '#ccc',
    "Foreground color": [],
    "Background color": []
  });
  const [selectedSection, setSelectedSection] = useState(null);
  const [savedTags, setSavedTags] = useState([]);
  const [selectedComposition, setSelectedComposition] = useState([]);
  const [blendPercentage, setBlendPercentage] = useState({
    "Cotton": 0,
    "Polyester": 0,
    "Viscose": 0,
    "Linen": 0,
    "Silk": 0,
    "Wool": 0,
    "Spandex": 0,
    "Nylon": 0,
    "Rayon": 0,
    "Modal": 0,
    "Tencel": 0,
    "Bamboo": 0,
    "Hemp": 0,
    "Jute": 0,
    "Acrylic": 0,
    "Other": 0
  });
  const [baseColorState, setBaseColorState] = useState({
    baseColor: {},
    foregroundColor: {},
    backgroundColor: {},
  });
  const [styleState, setStyleState] = useState({
    character: {},
    weave: {},
    blends: {},
    structure: {},
    yarnProperty: {},
    fabricFinish: {},
    style: {},
    pattern: {},
    printStyle: {},
    patternSize: {},
    sustainability: {},
    dyeTechnique: {},
    dyeUsed: {},
    denim: {},
    baseColor: {},
    foregroundColor: {},
    backgroundColor: {},
    fabricComposition: {}
  });
  const [fabricCategory, setFabricCategory] = useState("");
  const [season, setSeason] = useState("");
  const [category, setCategory] = useState([]); // now an array for multiple selection
  const [denim, setDenim] = useState("");
  const [sustainability, setSustainability] = useState("");
  const [dyeTechnique, setDyeTechnique] = useState("");
  const [dyeUsed, setDyeUsed] = useState("");
  const [patternSize, setPatternSize] = useState(""); 
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);  
  const [imageFile, setImageFile] = useState(null);
  const [tagIds, setTagIds] = useState([]); 
  const [blendTagPer, setBlendTagIdsPer] = useState([]);
  const [isAddFabricTagsSaved, setIsAddFabricTagsSaved] = useState(false);
  const searchParams = new URLSearchParams(window.location.search);
  const productId = searchParams.get("product_id");

  useEffect(() => {
    async function fetchformData() {
      try {
        const productData = await getData(
          "/api/product/get-product?product_id=" + productId
        );
        if (productData.data && productData.data.product) {
          setFormData(productData.data.product);
        }
        if (productData.data && productData.data.blend_percentages) {
          setBlendTagIdsPer(productData.data.blend_percentages || []);
            const updatedBlendPercentage = { ...blendPercentage };
            productData.data.blend_percentages.forEach((blend) => {
              if (blend.tag in updatedBlendPercentage) {
                console.log("Blend Percentage:", blend.tag, blend.blend_percentage);
                blendPercentage[blend.tag] = blend.blend_percentage;
              }
                
            updatedBlendPercentage[blend.tag] = blend.blend_percentage;
            });
            setBlendPercentage(updatedBlendPercentage);
            console.log("Blend Percentage:", updatedBlendPercentage);
            console.log(blendPercentage);
            
            
        }

        let resCategoryData = await getData("/api/product/get-fabric-category");
        let resTagData = await getData("/api/product/get-fabric-tags-admin");
        console.log("Fabric Categories:", resCategoryData);
        console.log("Fabric Tags:", resTagData);
        
        if (resCategoryData.data && resCategoryData.data.fabric_categories) {
          setFabricCategories(resCategoryData.data.fabric_categories);
        }
        
        if (resTagData.data && resTagData.data.fabric_tags) {
          setFabricTags(resTagData.data.fabric_tags);
        }
        
        setLoading(false);

        const savedTagIds = productData.data?.acc_product_details?.tag_ids || [];
        setTagIds(savedTagIds);

        const newStyleState = { ...styleState };
        const newBaseColorState = { ...baseColorState };

        if (resTagData.data?.fabric_tags) {
          Object.keys(resTagData.data.fabric_tags).forEach(section => {
            const sectionTags = resTagData.data.fabric_tags[section] || [];

            if (section === "Base color") {
              const savedBaseColorTags = sectionTags.filter(tag => savedTagIds.includes(tag.id));
              savedBaseColorTags.forEach(tag => {
                newBaseColorState.baseColor[tag.product_tag] = true;
              });
            }

            if (section === "Foreground color") {
              const savedForegroundColorTags = sectionTags.filter(tag => savedTagIds.includes(tag.id));
              savedForegroundColorTags.forEach(tag => {
                newBaseColorState.foregroundColor[tag.product_tag] = true;
              });
            }

            if (section === "Background color") {
              const savedBackgroundColorTags = sectionTags.filter(tag => savedTagIds.includes(tag.id));
              savedBackgroundColorTags.forEach(tag => {
                newBaseColorState.backgroundColor[tag.product_tag] = true;
              });
            }

            if (!newStyleState[section.toLowerCase()]) {
              newStyleState[section.toLowerCase()] = {};
            }

            sectionTags.forEach(tag => {
              if (savedTagIds.includes(tag.id)) {
                newStyleState[section.toLowerCase()][tag.product_tag] = true;

                if (section === "Fabric Category") {
                  setFabricCategory(tag.product_tag);
                }
                if (section === "Season") {
                  setSeason(tag.product_tag);
                }
                if (section === "Category") {
                  setCategory(tag.product_tag);
                }
                if (section === "Denim") {
                  setDenim(tag.product_tag);
                }
                if (section === "Sustainability") {
                  setSustainability(tag.product_tag);
                }
                if (section === "Pattern size") {
                  setPatternSize(tag.product_tag);
                }
                if (section === "Dye technique") {
                  setDyeTechnique(tag.product_tag);
                }
                if (section === "Dye used") {
                  setDyeUsed(tag.product_tag);
                }
              } else {
                newStyleState[section.toLowerCase()][tag.product_tag] = false;
              }
            });

            if (section === "Fabric composition") {
              const savedCompositionTags = sectionTags.filter(tag => savedTagIds.includes(tag.id));

              // setBlendPercentage(
              //   savedCompositionTags.reduce((acc, tag) => {
              //     acc[tag.product_tag] = tag.percentage || 0;
              //     return acc;
              //   }, {})
              // );

              if (!newStyleState["fabricComposition"]) {
                newStyleState["fabricComposition"] = {};
              }

              sectionTags.forEach(tag => {
                newStyleState["fabricComposition"][tag.product_tag] = false;
              });

              savedCompositionTags.forEach(tag => {
                newStyleState["fabricComposition"][tag.product_tag] = true;
              });

              setSelectedComposition(savedCompositionTags.map(tag => tag.product_tag));
            }

            if (section === "Blends") {
              const savedBlendTags = sectionTags.filter(tag => savedTagIds.includes(tag.id));

              if (!newStyleState["blends"]) {
                newStyleState["blends"] = {};
              }

              sectionTags.forEach(tag => {
                newStyleState["blends"][tag.product_tag] = false;
              });

              savedBlendTags.forEach(tag => {
                newStyleState["blends"][tag.product_tag] = true;
              });
            }

            if (section === "Print style") {
              const savedPrintStyleTags = sectionTags.filter(tag => savedTagIds.includes(tag.id));

              if (!newStyleState["printStyle"]) {
                newStyleState["printStyle"] = {};
              }

              sectionTags.forEach(tag => {
                newStyleState["printStyle"][tag.product_tag] = false;
              });

              savedPrintStyleTags.forEach(tag => {
                newStyleState["printStyle"][tag.product_tag] = true;
              });
            }

            if (section === "Pattern") {
              const savedPatternTags = sectionTags.filter(tag => savedTagIds.includes(tag.id));

              if (!newStyleState["pattern"]) {
                newStyleState["pattern"] = {};
              }

              sectionTags.forEach(tag => {
                newStyleState["pattern"][tag.product_tag] = false;
              });

              savedPatternTags.forEach(tag => {
                newStyleState["pattern"][tag.product_tag] = true;
              });
            }

            if (section === "Character") {
              const savedCharacterTags = sectionTags.filter(tag => savedTagIds.includes(tag.id));

              if (!newStyleState["character"]) {
                newStyleState["character"] = {};
              }

              sectionTags.forEach(tag => {
                newStyleState["character"][tag.product_tag] = false;
              });

              savedCharacterTags.forEach(tag => {
                newStyleState["character"][tag.product_tag] = true;
              });
            }

            if (section === "Weave") {
              const savedWeaveTags = sectionTags.filter(tag => savedTagIds.includes(tag.id));

              if (!newStyleState["weave"]) {
                newStyleState["weave"] = {};
              }

              sectionTags.forEach(tag => {
                newStyleState["weave"][tag.product_tag] = false;
              });

              savedWeaveTags.forEach(tag => {
                newStyleState["weave"][tag.product_tag] = true;
              });
            }

            if (section === "Structure") {
              const savedStructureTags = sectionTags.filter(tag => savedTagIds.includes(tag.id));

              if (!newStyleState["structure"]) {
                newStyleState["structure"] = {};
              }

              sectionTags.forEach(tag => {
                newStyleState["structure"][tag.product_tag] = false;
              });
              
              savedStructureTags.forEach(tag => {
                newStyleState["structure"][tag.product_tag] = true;
              });
            }
            
            if (section === "Yarn property") {
              const savedYarnPropertyTags = sectionTags.filter(tag => savedTagIds.includes(tag.id));
              
              if (!newStyleState["yarnProperty"]) {
                newStyleState["yarnProperty"] = {};
              }
              
              sectionTags.forEach(tag => {
                newStyleState["yarnProperty"][tag.product_tag] = false;
              });
              
              savedYarnPropertyTags.forEach(tag => {
                newStyleState["yarnProperty"][tag.product_tag] = true;
              });
            }
            
            if (section === "Fabric Finish") {
              const savedFabricFinishTags = sectionTags.filter(tag => savedTagIds.includes(tag.id));
              
              if (!newStyleState["fabricFinish"]) {
                newStyleState["fabricFinish"] = {};
              }

              sectionTags.forEach(tag => {
                newStyleState["fabricFinish"][tag.product_tag] = false;
              });

              savedFabricFinishTags.forEach(tag => {
                newStyleState["fabricFinish"][tag.product_tag] = true;
              });
            }
            
            if (section === "Style") {
              const savedStyleTags = sectionTags.filter(tag => savedTagIds.includes(tag.id));
              
              if (!newStyleState["style"]) {
                newStyleState["style"] = {};
              }

              sectionTags.forEach(tag => {
                newStyleState["style"][tag.product_tag] = false;
              });

              savedStyleTags.forEach(tag => {
                newStyleState["style"][tag.product_tag] = true;
              });
            }
          });
        }
        
        setStyleState(newStyleState);
        setBaseColorState(newBaseColorState);

        if (selectedSection && resTagData.data?.fabric_tags[selectedSection]) {
          const sectionTags = resTagData.data.fabric_tags[selectedSection];
          const savedSectionTags = sectionTags
            .filter(tag => savedTagIds.includes(tag.id))
            .map(tag => tag.product_tag);
          setSavedTags(savedSectionTags);
        }

      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    }

    fetchformData();
  }, [productId]);

  useEffect(() => {
    // Only run if blendTagPer and fabricTags are loaded
    if (
      selectedSection === "Fabric composition" &&
      blendTagPer &&
      fabricTags["Fabric composition"]
    ) {
      setStyleState((prev) => {
        const newFabricComposition = {};
        fabricTags["Fabric composition"].forEach((tag) => {
          newFabricComposition[tag.product_tag] = blendTagPer.some(
            (blend) => blend.tag === tag.product_tag
          );
        });
        return {
          ...prev,
          fabricComposition: newFabricComposition,
        };
      });
    }
  }, [blendTagPer, fabricTags, selectedSection]);
  
  // Helper to collect tag IDs from all sections except the selected one
  const collectTagIds = ({
    selectedSection,
    fabricTags,
    styleState,
    baseColorState,
    fabricCategory,
    patternSize,
    season,
    category,
    denim,
    sustainability,
    dyeTechnique,
    dyeUsed
  }) => {
    let allTagIds = [];
    const sectionKeys = Object.keys(fabricTags);
    sectionKeys.forEach(section => {
      if (section === selectedSection) return;
      switch (section) {
        case "Fabric Category": {
          const tag = fabricTags[section]?.find(tag => tag.product_tag === fabricCategory);
          if (tag) allTagIds.push(tag.id);
          break;
        }
        case "Blends": {
          const tags = fabricTags[section]?.filter(tag => styleState.blends?.[tag.product_tag]).map(tag => tag.id) || [];
          allTagIds.push(...tags);
          break;
        }
        case "Base color": {
          const tags = fabricTags[section]?.filter(tag => baseColorState.baseColor?.[tag.product_tag]).map(tag => tag.id) || [];
          allTagIds.push(...tags);
          break;
        }
        case "Foreground color": {
          const tags = fabricTags[section]?.filter(tag => baseColorState.foregroundColor?.[tag.product_tag]).map(tag => tag.id) || [];
          allTagIds.push(...tags);
          break;
        }
        case "Background color": {
          const tags = fabricTags[section]?.filter(tag => baseColorState.backgroundColor?.[tag.product_tag]).map(tag => tag.id) || [];
          allTagIds.push(...tags);
          break;
        }
        case "Pattern size": {
          const tag = fabricTags[section]?.find(tag => tag.product_tag === patternSize);
          if (tag) allTagIds.push(tag.id);
          break;
        }
        case "Print style": {
          const tags = fabricTags[section]?.filter(tag => styleState.printStyle?.[tag.product_tag]).map(tag => tag.id) || [];
          allTagIds.push(...tags);
          break;
        }
        case "Pattern": {
          const tags = fabricTags[section]?.filter(tag => styleState.pattern?.[tag.product_tag]).map(tag => tag.id) || [];
          allTagIds.push(...tags);
          break;
        }
        case "Character": {
          const tags = fabricTags[section]?.filter(tag => styleState.character?.[tag.product_tag]).map(tag => tag.id) || [];
          allTagIds.push(...tags);
          break;
        }
        case "Weave": {
          const tags = fabricTags[section]?.filter(tag => styleState.weave?.[tag.product_tag]).map(tag => tag.id) || [];
          allTagIds.push(...tags);
          break;
        }
        case "Structure": {
          const tags = fabricTags[section]?.filter(tag => styleState.structure?.[tag.product_tag]).map(tag => tag.id) || [];
          allTagIds.push(...tags);
          break;
        }
        case "Yarn property": {
          const tags = fabricTags[section]?.filter(tag => styleState.yarnProperty?.[tag.product_tag]).map(tag => tag.id) || [];
          allTagIds.push(...tags);
          break;
        }
        case "Fabric Finish": {
          const tags = fabricTags[section]?.filter(tag => styleState.fabricFinish?.[tag.product_tag]).map(tag => tag.id) || [];
          allTagIds.push(...tags);
          break;
        }
        case "Season": {
          const tag = fabricTags[section]?.find(tag => tag.product_tag === season);
          if (tag) allTagIds.push(tag.id);
          break;
        }
        case "Category": {
          // Multiple selection: collect all selected category tag IDs
          const tags = fabricTags[section]?.filter(tag => category.includes(tag.product_tag)).map(tag => tag.id) || [];
          allTagIds.push(...tags);
          break;
        }
        case "Style": {
          const tags = fabricTags[section]?.filter(tag => styleState.style?.[tag.product_tag]).map(tag => tag.id) || [];
          allTagIds.push(...tags);
          break;
        }
        case "Denim": {
          const tag = fabricTags[section]?.find(tag => tag.product_tag === denim);
          if (tag) allTagIds.push(tag.id);
          break;
        }
        case "Sustainability": {
          const tag = fabricTags[section]?.find(tag => tag.product_tag === sustainability);
          if (tag) allTagIds.push(tag.id);
          break;
        }
        case "Dye technique": {
          const tag = fabricTags[section]?.find(tag => tag.product_tag === dyeTechnique);
          if (tag) allTagIds.push(tag.id);
          break;
        }
        case "Dye used": {
          const tag = fabricTags[section]?.find(tag => tag.product_tag === dyeUsed);
          if (tag) allTagIds.push(tag.id);
          break;
        }
        case "Fabric composition": {
          const tags = fabricTags[section]?.filter(tag => styleState.fabricComposition?.[tag.product_tag]).map(tag => tag.id) || [];
          allTagIds.push(...tags);
          break;
        }
        default:
          break;
      }
    });
    return allTagIds;
  };

  const handleSubmit = async (tagIds) => {
    setLoading(true);

    let allTagIds = [...tagIds];
    allTagIds.push(
      ...collectTagIds({
        selectedSection,
        fabricTags,
        styleState,
        baseColorState,
        fabricCategory,
        patternSize,
        season,
        category,
        denim,
        sustainability,
        dyeTechnique,
        dyeUsed
      })
    );

    const uniqueTagIds = [...new Set(allTagIds)];

    let tagReqData = {
      product_id: productId ? productId : "",
      tag_ids: uniqueTagIds,
    };

    try {
      console.log("Sending tags:", tagReqData);
      const res = await postData("/api/product/save-fabric-tags", tagReqData);
      console.log(res);

      if (res["data"]["code"] === "200") {
        const productResponse = await getData(
          "/api/product/get-product?product_id=" + productId
        );
        if (productResponse.data && productResponse.data.acc_product_details) {
          setTagIds(productResponse.data.acc_product_details.tag_ids || []);
        }
        if (productResponse.data && productResponse.data.blend_percentages) {
          setBlendTagIdsPer(productResponse.data.blend_percentages || []);
        }

        setLoading(false);
        alert("Tag updated successfully");
        setIsAddFabricTagsSaved(true);
        if (onTagsSaved) {
          onTagsSaved();
        }
      } else {
        alert("Tag update failed");
        console.error("Failed to submit form:", res.statusText);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setLoading(false);
    }
  };

  const handleFabricCompositionSubmit = async (tagIds, blendPercentages) => {
    setLoading(true);

    if (tagIds.length > 1) {
      const totalPercentage = Object.values(blendPercentages).reduce(
        (sum, percentage) => sum + percentage,
        0
      );

      if (totalPercentage !== 100) {
        alert("Total blend percentage must be exactly 100%");
        setLoading(false);
        return;
      }
    }

    let allTagIds = [...tagIds];
    allTagIds.push(
      ...collectTagIds({
        selectedSection,
        fabricTags,
        styleState,
        baseColorState,
        fabricCategory,
        patternSize,
        season,
        category,
        denim,
        sustainability,
        dyeTechnique,
        dyeUsed
      })
    );

    const uniqueTagIds = [...new Set(allTagIds)];

    let tagReqData = {
      product_id: productId ? productId : "",
      tag_ids: uniqueTagIds,
      ...(tagIds.length > 1 ? { blend_percentages: blendPercentages } : {}),
    };

    try {
      console.log("Sending tags:", tagReqData);
      const res = await postData("/api/product/save-fabric-tags", tagReqData);
      console.log(res);

      if (res["data"]["code"] === "200") {
        const productResponse = await getData(
          "/api/product/get-product?product_id=" + productId
        );
        if (productResponse.data && productResponse.data.acc_product_details) {
          setTagIds(productResponse.data.acc_product_details.tag_ids || []);
          // --- Sync styleState.fabricComposition with new tagIds ---
          const newFabricComposition = {};
          const tags = fabricTags["Fabric composition"] || [];
          tags.forEach(tag => {
            newFabricComposition[tag.product_tag] = (productResponse.data.acc_product_details.tag_ids || []).includes(tag.id);
          });
          setStyleState(prev => ({
            ...prev,
            fabricComposition: newFabricComposition
          }));
        }
        if (productResponse.data && productResponse.data.blend_percentages) {
          if (tagIds.length > 0) {
            for (let i = 0; i < tagIds.length; i++) {
              const tagId = tagIds[i];
              const blendTag = productResponse.data.blend_percentages.find(
                (blend) => blend.tag === tagId
              );
              if (blendTag) {
                setBlendTagIdsPer((prevBlendTagIds) => [
                  ...prevBlendTagIds,
                  { name: blendTag.tag, percentage: blendTag.blend_percentage },
                ]);
              }
            }
            setBlendTagIdsPer(productResponse.data.blend_percentages || []);
          }
        }

        setLoading(false);
        alert("Tag updated successfully");
        setIsAddFabricTagsSaved(true);
        if (onTagsSaved) {
          onTagsSaved();
        }
      } else {
        alert("Tag update failed");
        console.error("Failed to submit form:", res.statusText);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setLoading(false);
    }
  };

  const handleSubmitBaseColor = async (tagIds) => {
    setLoading(true);

    let allTagIds = [...tagIds];
    allTagIds.push(
      ...collectTagIds({
        selectedSection,
        fabricTags,
        styleState,
        baseColorState,
        fabricCategory,
        patternSize,
        season,
        category,
        denim,
        sustainability,
        dyeTechnique,
        dyeUsed
      })
    );

    const uniqueTagIds = [...new Set(allTagIds)];

    let tagReqData = {
      product_id: productId ? productId : "",
      tag_ids: uniqueTagIds,
    };

    try {
      console.log("Sending tags:", tagReqData);
      const res = await postData("/api/product/save-fabric-tags", tagReqData);
      console.log(res);

      if (res["data"]["code"] === "200") {
        const productResponse = await getData(
          "/api/product/get-product?product_id=" + productId
        );
        if (productResponse.data && productResponse.data.acc_product_details) {
          setTagIds(productResponse.data.acc_product_details.tag_ids || []);
        }

        setLoading(false);
        alert("Tag updated successfully");
        setIsAddFabricTagsSaved(true);
        if (onTagsSaved) {
          onTagsSaved();
        }
      } else {
        alert("Tag update failed");
        console.error("Failed to submit form:", res.statusText);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setLoading(false);
    }
  };

  const handleToggle = (label) => {
    setSelectedSection(label);
    setSavedTags([]);
  };

  const handleSliderChange = (type, newValue) => {
    if (selectedSection === "Fabric composition") {
      const selectedTags = Object.keys(styleState.fabricComposition)
      .filter(key => styleState.fabricComposition[key]);

      // Number of tags to fix: all except last two (if more than 2), else fix all but last
      const total = selectedTags.length;
      let fixedCount = Math.max(0, total - 2);

      // If only one tag, just set its value
      if (total === 1) {
      setBlendPercentage(prev => ({ ...prev, [type]: newValue }));
      return;
      }

      // If two tags, fix the first, update the second
      if (total === 2) {
      const [first, second] = selectedTags;
      if (type === first) {
        // Clamp value between 0 and 100
        let clamped = Math.max(0, Math.min(newValue, 100));
        setBlendPercentage(prev => ({
        ...prev,
        [first]: clamped,
        [second]: 100 - clamped
        }));
      } else {
        let clamped = Math.max(0, Math.min(newValue, 100));
        setBlendPercentage(prev => ({
        ...prev,
        [first]: 100 - clamped,
        [second]: clamped
        }));
      }
      return;
      }

      // For 3 or more tags
      // Fix the first N (N = total-2), update only the last two
      const fixedTags = selectedTags.slice(0, fixedCount);
      const editableTags = selectedTags.slice(fixedCount);

      // Calculate sum of fixed tags
      const fixedSum = fixedTags.reduce((sum, tag) => sum + (blendPercentage[tag] || 0), 0);

      // If type is one of the fixed tags, just update its value and adjust the last two accordingly
      if (fixedTags.includes(type)) {
      // Clamp value so that sum of fixed tags does not exceed 100
      let otherFixedSum = fixedTags.reduce((sum, tag) => tag === type ? sum : sum + (blendPercentage[tag] || 0), 0);
      let clamped = Math.max(0, Math.min(newValue, 100 - otherFixedSum));
      let newBlend = { ...blendPercentage, [type]: clamped };

      // Recalculate fixedSum after update
      let newFixedSum = otherFixedSum + clamped;
      let remaining = 100 - newFixedSum;

      // Distribute remaining among editable tags, keep their ratio if possible
      let prevSum = editableTags.reduce((sum, tag) => sum + (blendPercentage[tag] || 0), 0);
      editableTags.forEach((tag, idx) => {
        if (idx === editableTags.length - 1) {
        // Last tag gets the remainder
        newBlend[tag] = remaining - editableTags.slice(0, -1).reduce((s, t) => s + (newBlend[t] || 0), 0);
        } else {
        let prev = blendPercentage[tag] || 0;
        let value = prevSum > 0 ? Math.round((prev / prevSum) * remaining) : Math.floor(remaining / editableTags.length);
        newBlend[tag] = value;
        }
      });

      setBlendPercentage(newBlend);
      return;
      }

      // If type is one of the editable tags
      if (editableTags.includes(type)) {
      // Only allow sum of editable tags to be <= (100 - fixedSum)
      let otherEditableSum = editableTags.reduce((sum, tag) => tag === type ? sum : sum + (blendPercentage[tag] || 0), 0);
      let maxValue = 100 - fixedSum - otherEditableSum;
      let clamped = Math.max(0, Math.min(newValue, 100 - fixedSum));
      let newBlend = { ...blendPercentage, [type]: clamped };

      // Now, sum of editable tags (after this change)
      let editableSum = editableTags.reduce((sum, tag) => sum + (newBlend[tag] || 0), 0);
      let diff = (100 - fixedSum) - editableSum;

      // Distribute diff to the other editable tag(s)
      const otherEditableTags = editableTags.filter(tag => tag !== type);
      if (otherEditableTags.length === 1) {
        newBlend[otherEditableTags[0]] = (blendPercentage[otherEditableTags[0]] || 0) + diff;
      } else if (otherEditableTags.length > 1) {
        // Distribute equally if more than one
        let perTag = Math.floor(diff / otherEditableTags.length);
        let distributed = 0;
        otherEditableTags.forEach((tag, idx) => {
        if (idx === otherEditableTags.length - 1) {
          newBlend[tag] = (blendPercentage[tag] || 0) + (diff - distributed);
        } else {
          newBlend[tag] = (blendPercentage[tag] || 0) + perTag;
          distributed += perTag;
        }
        });
      }

      setBlendPercentage(newBlend);
      return;
      }

      // Fallback: just update
      setBlendPercentage(prev => ({ ...prev, [type]: newValue }));
    } else {
      setBlendPercentage(prev => ({ ...prev, [type]: newValue }));
    }

  };  

  const handleCheckboxChange = (section, tag) => {
    setStyleState((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [tag]: !prev[section][tag]
      }
    }));
  };

  const handleColorChange = (colorType, tag) => {
    setBaseColorState((prev) => ({
      ...prev,
      [colorType]: { ...prev[colorType], [tag]: !prev[colorType][tag] },
    }));
  };

  const handleOpen = (imgSrc) => {
    setSelectedImage(imgSrc);
    setOpen(true);
  };

  const [newTagDialogOpen, setNewTagDialogOpen] = useState(false);
  const [newTagData, setNewTagData] = useState({
    product_tag: "",
  });

  const [tagImageUrl, setTagImageUrl] = useState("");
  const [failedImages, setFailedImages] = useState({});

  // Helper function to clean base64 data
  const cleanBase64Data = (url) => {
    if (!url) return null;
    
    // If it's already a proper data URL, extract just the base64 data
    if (url.includes('data:image/jpeg;base64,')) {
      // Get the last occurrence in case of duplicates
      return url.split('data:image/jpeg;base64,').pop();
    }
    
    // If it's just base64 data, return as is
    return url;
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const img = new Image();
        img.src = reader.result;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = 120;
          canvas.height = 60;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, 120, 60);
          // Get just the base64 data without the prefix
          const base64String = canvas.toDataURL('image/jpeg', 0.8).split('data:image/jpeg;base64,')[1];
          resolve(base64String);
        };
        img.onerror = () => reject(new Error('Failed to load image'));
      };
      reader.onerror = error => reject(error);
    });
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      try {
        const base64Image = await convertToBase64(file);
        setTagImageUrl(base64Image);
        setImageFile(file);
      } catch (error) {
        console.error('Error processing image:', error);
        alert('Error processing image. Please try a different image.');
      }
    }
  };

  const handleCreateNewTag = async () => {
    try {
      const currentCategory = fabricCategories.find(
        (cat) => cat.category === selectedSection
      );

      if (!currentCategory) {
        alert("Could not determine category");
        return;
      }

      // Format: Capitalize first letter, rest lowercase
      const formattedTag =
        newTagData.product_tag.trim().charAt(0).toUpperCase() +
        newTagData.product_tag.trim().slice(1).toLowerCase();

      const existingTags = fabricTags[selectedSection] || [];
      const isDuplicate = existingTags.some(
        tag => tag.product_tag.trim().toLowerCase() === formattedTag.toLowerCase()
      );

      if (isDuplicate) {
        alert(`A tag with the name "${formattedTag}" already exists in the ${selectedSection} section. Please choose a different name.`);
        return;
      }

      // Also check against all tags in the master list
      try {
        const tagMasterResponse = await getData("/api/product/acc_tag_master");
        if (tagMasterResponse.data && tagMasterResponse.data.tag_masters) {
          const masterTags = tagMasterResponse.data.tag_masters;
          const isDuplicateInMaster = masterTags.some(
            tag => tag.product_tag.trim().toLowerCase() === formattedTag.toLowerCase() && 
                   tag.category === currentCategory.id
          );

          if (isDuplicateInMaster) {
            alert(`A tag with the name "${formattedTag}" already exists in the ${selectedSection} section. Please choose a different name.`);
            return;
          }
        }
      } catch (error) {
        console.error("Error checking tag master:", error);
        // Continue with tag creation even if master check fails
      }

      let base64Image = "";
      if (imageFile) {
        try {
          base64Image = await convertToBase64(imageFile);
        } catch (error) {
          console.error("Image conversion error:", error);
          alert("Failed to process image. Please try again with a different image.");
          return;
        }
      }

      const payload = {
        'product_tag': formattedTag,
        'tag_family': currentCategory.tag_family,
        'category': currentCategory.id,
        'created_by': "admin",
        'updated_by': "admin",
        'status': 1,
        'image_url': base64Image, 
        'is_assigned': false,
      };

      const res = await postData("/api/product/acc_tag_master", payload);

      if (res.data.code === "200") {
        // Refresh the tags data
        const tagsResponse = await getData("/api/product/get-fabric-tags-admin");
        if (tagsResponse.data && tagsResponse.data.fabric_tags) {
          setFabricTags(tagsResponse.data.fabric_tags);
        }

        setNewTagData({
          product_tag: "",
        });
        setTagImageUrl("");
        setImageFile(null);
        setNewTagDialogOpen(false);
        alert("Tag created successfully");
      } else {
        alert("Tag creation failed");
      }
    } catch (error) {
      console.error("Error creating tag:", error);
      alert(`Error: ${error.response?.data?.message || "Server error"}`);
    }
  };

  const handleChevronClick = (direction) => {
    const sections = [
      "Fabric composition",
      //"Blends",
      "Base color",
      "Pattern size",
      "Print style",
      "Pattern",
      "Character",
      "Weave",
      "Structure",
      "Yarn property",
      "Fabric Finish",
      "Season",
      "Category",
      "Style",
      "Denim",
      "Sustainability",
      "Dye technique",
      "Dye used",
    ];

    const currentIndex = sections.indexOf(selectedSection);
    let newIndex;

    if (direction === "left") {
      newIndex = (currentIndex - 1 + sections.length) % sections.length;
    } else if (direction === "right") {
      newIndex = (currentIndex + 1) % sections.length;
    }

    setSelectedSection(sections[newIndex]);
  };

  const hasSavedTags = (category) => {
    // Special case for Fabric composition button
    if (category.category === "Fabric composition") {
      const tagsInSection = fabricTags["Fabric composition"] || [];
      return tagsInSection.some(tag => tagIds.includes(tag.id));
    }
    // Normal case for other categories
    const tagsInCategory = fabricTags[category.category] || [];
    return tagsInCategory.some(tag => tagIds.includes(tag.id));
  };

  return (
    <Box sx={{ padding: 0, maxWidth: "1200px", margin: "20px auto" }}>
      {/* Dropdowns */}
      <Accordion
        sx={{
          mt: 2,
          backgroundColor: "#F3F4F6",
          boxShadow: 0,
          borderRadius: 0,
        }}
      >
        <AccordionSummary
          sx={{ display: "flex", alignItems: "center", gap: 2, height: 58 }}
        >
          <Typography
            variant="h7"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              fontWeight: "bold",
              mr: 11.6,
            }}
          >
            Add Fabric Tags
          </Typography>
          {/* Expand icon just right of text */}
          <ExpandMoreIcon />
          {/* Check icon at far right, absolutely positioned */}
          <span
            style={{
              position: "absolute",
              right: 16,
              top: "50%",
              transform: "translateY(-50%)",
              pointerEvents: "auto",
              cursor: "pointer",
            }}
          >
            {isAddFabricTagsSaved ? (
              <CheckCircleIcon sx={{ color: "#565E6D" }} />
            ) : (
              <RadioButtonUncheckedIcon />
            )}
          </span>          
        </AccordionSummary>
        <AccordionDetails>
          <div
            style={{
              display: "grid",
              // gridTemplateColumns: "repeat(5, 1fr)",
              gap: "20px",
              padding: 20,
              paddingTop: 6,
            }}
          >
            <div style={{ display: "flex", flexDirection: "row", gap: "32px", alignItems: "flex-start" }}>
              {/* Fabric Details */}
              <div>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: "bold", mb: 1, whiteSpace: "nowrap" }}
                >
                  1 Fabric details
                </Typography>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    flexWrap: "nowrap",
                    alignItems: "center",
                    overflowX: "auto",
                  }}
                > 
                  {fabricCategories
                    .filter(
                      (category) => 
                        category.tag_family === 2 && 
                        category.category !== "Fabric Category" 
                    )
                    .map((category) => (
                      <Button
                        key={category.id}
                        onClick={() => handleToggle(category.category)}
                        sx={{
                          borderRadius: "20px",
                          fontSize: "12px",
                          padding: "4px 10px",
                          minWidth: "70px",
                          whiteSpace: "nowrap",
                          display: "flex",
                          border: "1px solid #565E6D",
                          backgroundColor: category.category === selectedSection
                            ? "#000"
                            : hasSavedTags(category)
                              ? "#565E6D"
                              : "#fff",
                          color: category.category === selectedSection
                            ? "#fff"
                            : hasSavedTags(category)
                              ? "#fff"
                              : "#565E6D",
                          "&:hover": {
                            backgroundColor: category.category === selectedSection
                              ? "#222"
                              : hasSavedTags(category)
                                ? "#565E6D"
                                : "#fff",
                            color: category.category === selectedSection
                              ? "#fff"
                              : hasSavedTags(category)
                                ? "#fff"
                                : "#565E6D",
                          },
                          textTransform: "none", 
                        }}
                      >
                        {category.category.charAt(0).toUpperCase() + category.category.slice(1).toLowerCase()}
                      </Button>
                    ))}
                </div>
              </div>

              {/* Design Related */}
              <div>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: "bold", mb: 1, whiteSpace: "nowrap" }}
                >
                  2 Design related
                </Typography>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    flexWrap: "nowrap",
                    alignItems: "center",
                    overflowX: "auto",
                  }}
                >
                  {fabricCategories
                    .filter(
                      (category) =>
                        category.tag_family === 3 &&
                        category.category !== "Foreground color" &&
                        category.category !== "Background color"
                    )
                    .map((category) => {
                      // Custom label logic (add more if needed)
                      let label = category.category;
                      if (label === "Base color") label = "Color";
                      // Capitalize first letter, rest lowercase
                      label = label.charAt(0).toUpperCase() + label.slice(1).toLowerCase();
                      return (
                        <Button
                          key={category.id}
                          onClick={() => handleToggle(category.category)}
                          sx={{
                            borderRadius: "20px",
                            fontSize: "12px",
                            padding: "4px 10px",
                            minWidth: "70px",
                            whiteSpace: "nowrap",
                            display: "flex",
                            border: "1px solid #565E6D",
                            backgroundColor: category.category === selectedSection
                              ? "#000"
                              : hasSavedTags(category)
                                ? "#565E6D"
                                : "#fff",
                            color: category.category === selectedSection
                              ? "#fff"
                              : hasSavedTags(category)
                                ? "#fff"
                                : "#565E6D",
                            "&:hover": {
                              backgroundColor: category.category === selectedSection
                                ? "#222"
                                : hasSavedTags(category)
                                  ? "#565E6D"
                                  : "#fff",
                              color: category.category === selectedSection
                                ? "#fff"
                                : hasSavedTags(category)
                                  ? "#fff"
                                  : "#565E6D",
                            },
                            textTransform: "none",
                          }}
                        >
                          {label}
                        </Button>
                      );
                    })}
                </div>
              </div>

              {/* Look & Feel */}
                <div>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", mb: 1, whiteSpace: "nowrap" }}
                  >
                    3 Look & Feel
                  </Typography>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "8px",
                      flexWrap: "nowrap",
                      alignItems: "center",
                      overflowX: "auto",
                    }}
                  >
                    {fabricCategories
                      .filter((category) => category.tag_family === 4)
                      .map((category) => {
                        // Custom label logic (add more if needed)
                        let label = category.category;                        
                        if (label === "Fabric Finish") label = "Finish";
                        // Capitalize first letter, rest lowercase
                        label = label.charAt(0).toUpperCase() + label.slice(1).toLowerCase();
                        return (
                          <Button
                            key={category.id}
                            onClick={() => handleToggle(category.category)}
                            sx={{
                              borderRadius: "20px",
                              fontSize: "12px",
                              padding: "4px 10px",
                              minWidth: "70px",
                              whiteSpace: "nowrap",
                              display: "flex",
                              border: "1px solid #565E6D",
                              backgroundColor: category.category === selectedSection
                                ? "#000"
                                : hasSavedTags(category)
                                  ? "#565E6D"
                                  : "#fff",
                              color: category.category === selectedSection
                                ? "#fff"
                                : hasSavedTags(category)
                                  ? "#fff"
                                  : "#565E6D",
                              "&:hover": {
                                backgroundColor: category.category === selectedSection
                                  ? "#222"
                                  : hasSavedTags(category)
                                    ? "#565E6D"
                                    : "#fff",
                                color: category.category === selectedSection
                                  ? "#fff"
                                  : hasSavedTags(category)
                                    ? "#fff"
                                    : "#565E6D",
                              },
                              textTransform: "none",
                            }}
                          >
                            {label}
                          </Button>
                        );
                      })}
                  </div>
                </div>
            </div>
          </div>

          {/* Dotted Divider */}
          <div
            style={{
              borderTop: "2px dotted #BCC1CA",
              width: "calc(100% - 50px)",
              padding: 5,
              marginLeft: 20,
            }}
          />

          {/* Season & Category */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(5, 1fr)",
              gap: "50px",
              padding: 20,
              paddingTop: 0,
            }}
          >
            <div>
              <Typography
                variant="body1"
                sx={{ fontWeight: "bold", mb: 1, whiteSpace: "nowrap" }}
              >
                4 Product related
              </Typography>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "8px",
                  flexWrap: "nowrap",
                  alignItems: "center",
                  overflowX: "auto",
                }}
              >
                {fabricCategories
                  .filter((category) => category.tag_family === 6)
                  .map((category) => (
                    <Button
                      key={category.id}
                      onClick={() => handleToggle(category.category)}
                      sx={{
                        borderRadius: "20px",
                        fontSize: "12px",
                        padding: "4px 10px",
                        minWidth: "70px",
                        whiteSpace: "nowrap",
                        display: "flex",
                        border: "1px solid #565E6D",
                        backgroundColor: category.category === selectedSection
                          ? "#000"
                          : hasSavedTags(category)
                            ? "#565E6D"
                            : "#fff",
                        color: category.category === selectedSection
                          ? "#fff"
                          : hasSavedTags(category)
                            ? "#fff"
                            : "#565E6D",
                        "&:hover": {
                          backgroundColor: category.category === selectedSection
                            ? "#222"
                            : hasSavedTags(category)
                              ? "#565E6D"
                              : "#fff",
                          color: category.category === selectedSection
                            ? "#fff"
                            : hasSavedTags(category)
                              ? "#fff"
                              : "#565E6D",
                        },
                        textTransform: "none",
                      }}
                    >
                      {category.category.charAt(0).toUpperCase() + category.category.slice(1).toLowerCase()}
                    </Button>
                  ))}
              </div>
            </div>

            {/* Processing */}
            <div>
              <Typography
                variant="body1"
                sx={{ fontWeight: "bold", mb: 1, whiteSpace: "nowrap" }}
              >
                5 Technical
              </Typography>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "8px",
                  flexWrap: "nowrap",
                  alignItems: "center",
                  overflowX: "auto",
                }}
              >
                {fabricCategories
                  .filter((category) => category.tag_family === 7)
                  .map((category) => (
                    <Button
                      key={category.id}
                      onClick={() => handleToggle(category.category)}
                      sx={{
                        borderRadius: "20px",
                        fontSize: "12px",
                        padding: "4px 10px",
                        minWidth: "70px",
                        whiteSpace: "nowrap",
                        display: "flex",
                        border: "1px solid #565E6D",
                        backgroundColor: category.category === selectedSection
                          ? "#000"
                          : hasSavedTags(category)
                            ? "#565E6D"
                            : "#fff",
                        color: category.category === selectedSection
                          ? "#fff"
                          : hasSavedTags(category)
                            ? "#fff"
                            : "#565E6D",
                        "&:hover": {
                          backgroundColor: category.category === selectedSection
                            ? "#222"
                            : hasSavedTags(category)
                              ? "#565E6D"
                              : "#fff",
                          color: category.category === selectedSection
                            ? "#fff"
                            : hasSavedTags(category)
                              ? "#fff"
                              : "#565E6D",
                        },
                        textTransform: "none",
                      }}
                    >
                      {category.category.charAt(0).toUpperCase() + category.category.slice(1).toLowerCase()}
                    </Button>
                  ))}
              </div>
            </div>
          </div>
          <Grid
            container
            sx={{
              backgroundColor: "#F3F4F6",
              padding: 2,
              borderRadius: "0px",
              maxWidth: "1210px",
            }}
          >
            {/* Image Placeholder */}
            <Grid item xs={12} sm={4}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "240px",
                  border: "2px solid #ccc",
                  borderRadius: "0px",
                  backgroundColor: "white",
                  cursor: "pointer",
                }}
                style={{ marginRight: 0, marginLeft: 0, marginTop: 10 }}
                onClick={() => handleOpen(formData.ps_product_productimg)}                
              >
                {formData.ps_product_productimg ? (  
                  <img
                    src={`https://www.ambikacc.com/product-profile-temp/medium-${formData.ps_product_productimg.split(",")[0].trim()}`}
                    alt="Product"
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                ) : (
                    <LandscapeIcon fontSize="large" sx={{ color : '#BCC1CA' }} />
                )}  
              </Box>
            </Grid>

            {/* Input Fields */}
            <Grid item xs={12} sm={8}>
              <Grid container spacing={2} sx={{ ml: 1 }}>
                {/* Header Inputs */}
                <Grid item xs={12} sx={{ display: "flex", gap: 2, mt: 2 }}>
                  <Box sx={{ display: "flex", alignItems: "center", flex: 1 }}>
                    <Typography sx={{ fontWeight: "bold" }}>
                      Predefined information{" "}
                    </Typography>
                  </Box>
                </Grid>

                {/* Left Column */}
                <Grid item xs={12} sm={6}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "16px",
                    }}
                  >
                    <label htmlFor="count" style={{ width: "120px" }}>
                      Count :
                    </label>
                    <input
                      id="count"
                      type="text"
                      style={{
                        flex: 1,
                        padding: "6px",
                        border: "1px solid #f1f4f6",
                        borderRadius: "0px",
                        backgroundColor: "#F3F4F6",
                      }}
                      value={formData.ps_product_count || ""}
                      disabled
                    />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "16px",
                    }}
                  >
                    <label htmlFor="construction" style={{ width: "120px" }}>
                      Construction :
                    </label>
                    <input
                      id="construction"
                      type="text"
                      style={{
                        flex: 1,
                        padding: "6px",
                        border: "1px solid #f1f4f6",
                        borderRadius: "0px",
                        backgroundColor: "#F3F4F6",
                      }}
                      value={formData.ps_product_construction || ""}
                      disabled
                    />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "16px",
                    }}
                  >
                    <label htmlFor="gsm" style={{ width: "120px" }}>
                      GSM : 
                    </label>
                    <input
                      id="gsm"
                      type="text"
                      style={{
                        flex: 1,
                        padding: "6px",
                        border: "1px solid #f1f4f6",
                        borderRadius: "0px",
                        backgroundColor: "#F3F4F6",
                      }}
                      value={
                        formData.ps_product_color1
                          ? formData.ps_product_color1.split(":")[1]?.trim()
                          : ""
                      }
                      disabled
                    />
                  </Box>
                </Grid>

                {/* Right Column */}
                <Grid item xs={12} sm={6}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "16px",
                    }}
                  >
                    <label htmlFor="width" style={{ width: "120px" }}>
                      Width : 
                    </label>
                    <input
                      id="width"
                      type="text"
                      style={{
                        flex: 1,
                        padding: "6px",
                        border: "1px solid #f1f4f6",
                        borderRadius: "0px",
                        backgroundColor: "#F3F4F6",
                      }}
                      value={formData.ps_product_width || ""}
                      disabled
                    />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "16px",
                    }}
                  >
                    <label htmlFor="fabricCategory" style={{ width: "140px" }}>
                      Fabric category :
                    </label>
                    <input
                      id="fabricCategory"
                      type="text"
                      style={{
                        flex: 1,
                        padding: "6px",
                        border: "1px solid #f1f4f6",
                        borderRadius: "0px",
                        backgroundColor: "#F3F4F6",
                      }}
                      value={formData.ps_product_cat || ""}
                      disabled
                    />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "16px",
                    }}
                  >
                    <label htmlFor="fabricType" style={{ width: "120px" }}>
                      Fabric type :
                    </label>
                    <input
                      id="fabricType"
                      type="text"
                      style={{
                        flex: 1,
                        padding: "6px",
                        border: "1px solid #f1f4f6",
                        borderRadius: "0px",
                        backgroundColor: "#F3F4F6",
                      }}
                      value={formData.ps_product_type || ""}
                      disabled
                    />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* Fabric Composition Section */}
          {selectedSection === "Fabric composition" && (
            <div
              style={{
                marginTop: "20px",
                padding: "10px",
                backgroundColor: "#F3F4F6",
                borderRadius: "0px",
                borderTop: "2px solid #ccc",
              }}
            >
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Fabric Composition
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "8px",
                  mb: 4,
                  mt: 3,
                  "& .MuiFormControlLabel-root": {
                    mr: 2,
                    ml: 0,
                  },
                }}
              >
                {fabricTags["Fabric composition"]?.map((tag) => (
                  <FormControlLabel
                    key={tag.id}
                    control={
                      <Checkbox
                        checked={
                          styleState.fabricComposition[tag.product_tag] || false
                        }
                        onChange={() =>
                          handleCheckboxChange(
                            "fabricComposition",
                            tag.product_tag
                          )
                        }
                        sx={{
                          color: "#565E6D",
                          "&.Mui-checked": { color: "#565E6D" },
                          padding: "4px",
                        }}
                      />
                    }
                    label={
                      tag.product_tag.charAt(0).toUpperCase() +
                      tag.product_tag.slice(1)
                    }
                  />
                ))}
              </Box>

              {/* Blend Percentage Section */}
              {Object.keys(styleState.fabricComposition).filter(
                (key) => styleState.fabricComposition[key]
              ).length > 1 && (
                <Box sx={{ mt: 2 }}>
                  <Typography
                    variant="body1"
                    sx={{
                      // fontWeight: "bold",
                      mb: 3,
                      fontSize: "1rem",
                    }}
                  >
                    Define blend percentage
                  </Typography>

                  {/* Vertical slider layout */}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 3,
                      width: "100%",
                    }}
                  >
                    {fabricTags["Fabric composition"]?.map(
                      (tag) =>
                        styleState.fabricComposition[tag.product_tag] && (
                          <Box
                            key={tag.id}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 2,
                              width: "100%",
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{
                                minWidth: "100px",
                                fontSize: "1rem",
                              }}
                            >
                              {tag.product_tag}
                            </Typography>
                            <Slider
                              value={blendPercentage[tag.product_tag] || 0}
                              onChange={(e, newValue) =>
                                handleSliderChange(tag.product_tag, newValue)
                              }
                              min={0}
                              max={100}
                              size="small"
                              sx={{
                                width: "250px",
                                color: "#565E6D",
                                "& .MuiSlider-rail": {
                                  height: 4,
                                },
                                "& .MuiSlider-track": {
                                  height: 4,
                                },
                                "& .MuiSlider-thumb": {
                                  width: 14,
                                  height: 14,
                                  backgroundColor: "#fff",
                                  border: "2px solid #565E6D",
                                },
                              }}
                            />
                            <Box
                              sx={{
                                width: "60px",
                                height: "30px",
                                border: "1px solid #ddd",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "1rem",
                                backgroundColor: "#fff",
                              }}
                            >
                              {blendPercentage[tag.product_tag] || 0}%
                            </Box>
                          </Box>
                        )
                    )}
                  </Box>
                </Box>
              )}

              {/* Create New Tag Button */}
              <Button
                startIcon={<AddCircleOutlineIcon />}
                sx={{
                  mt: 4.5,
                  width: 200,
                  height: 28,
                  border: "1px solid #ccc",
                  borderRadius: "0px",
                  backgroundColor: "white",
                  color: "black",
                  fontWeight: "bold",
                  "&:hover": { backgroundColor: "#b1b4b6" },
                }}
                onClick={() => setNewTagDialogOpen(true)}
              >
                Create New Tag
              </Button>

              {/* Save Button */}
              <Box
                sx={{
                  mt: 4,
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Button
                  onClick={() => handleChevronClick("left")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  &lt; Previous
                </Button>
                <Button
                  onClick={async () => {
                    // Get selected tag IDs
                    const selectedIds = Object.keys(styleState.fabricComposition)
                      .filter(key => styleState.fabricComposition[key])
                      .map(key => {
                        const tag = fabricTags["Fabric composition"]?.find(
                          tag => tag.product_tag === key
                        );
                        return tag?.id;
                      })
                      .filter(Boolean);

                    // Get blend percentages for selected tag
                    const blendPercentages = {};
                    Object.keys(styleState.fabricComposition)
                      .filter(key => styleState.fabricComposition[key])
                      .forEach(key => {                        
                          blendPercentages[key] = blendPercentage[key] || 0;                        
                      });

                    // If only one tag is selected, allow saving even if blend % is 0
                    // If more than one, filter out tags with 0% blend
                    let filteredTagIds = selectedIds;
                    let filteredBlendPercentages = blendPercentages;
                    if (selectedIds.length > 1) {
                      filteredTagIds = selectedIds.filter(id => {
                        const tag = fabricTags["Fabric composition"]?.find(tag => tag.id === id);
                        return tag && blendPercentage[tag.product_tag] > 0;
                      });
                      filteredBlendPercentages = {};
                      filteredTagIds.forEach(id => {
                        const tag = fabricTags["Fabric composition"]?.find(tag => tag.id === id);
                        if (tag) filteredBlendPercentages[tag.product_tag] = blendPercentage[tag.product_tag];
                      });
                    }

                    await handleFabricCompositionSubmit(
                      filteredTagIds,
                      selectedIds.length > 1 ? filteredBlendPercentages : blendPercentages
                    );
                  }}
                  sx={{
                    backgroundColor: "#565E6D",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#546e7a" },
                    borderRadius: "0px",
                  }}
                >
                  Save Changes
                </Button>
                <Button
                  onClick={() => handleChevronClick("right")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  Next &gt;
                </Button>
              </Box>

              {/* Saved Tags Display */}
              <Box sx={{ mt: 4 }}>
                <Typography variant="body1" sx={{ fontWeight: "bold", mb: 2 }}>
                  Saved Tag(s)
                </Typography>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    marginTop: "10px",
                  }}
                >
                  {(() => {
                    //const apiTags = fabricTags["Fabric composition"]?.filter(tag => tagIds.includes(tag.id));
                    if (blendTagPer && blendTagPer.length > 0) {
                      return blendTagPer.map((blend, index) => (
                        <Chip
                          key={index}
                          label={`${blend.tag} ${blend.blend_percentage || 0}%`}
                          sx={{
                            backgroundColor: "#565E6D",
                            color: "#fff",
                            borderRadius: "4px",
                          }}
                        />
                      ));
                    }
                    
                    return (
                      <Typography variant="body1">
                        No saved tags found.
                      </Typography>
                    );
                  })()}
                </div>
              </Box>
            </div>
          )}

          {/* Blends Section */}
          {selectedSection === "Blends" && (
            <div
              style={{
                marginTop: "20px",
                padding: "10px",
                backgroundColor: "#F3F4F6",
                borderRadius: "0px",
                borderTop: "2px solid #ccc",
              }}
            >
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Blends
              </Typography>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "start",
                  gap: "20px",
                  marginTop: "20px",
                }}
              >
                {fabricTags["Blends"]?.map((tag) => {
                  return (
                  <div key={tag.id} style={{ textAlign: "start" }}>
                    <div
                      style={{
                        width: "122px",
                        height: "68px",
                        backgroundColor: "white",
                        borderRadius: "0px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        border: styleState.blends[tag.product_tag]
                          ? "2px solid #565E6D"
                          : "2px solid transparent",
                      }}
                      onClick={() =>
                        handleCheckboxChange("blends", tag.product_tag)
                      }
                    >
                      {tag.image_url ? (
                        <img 
                          src={`data:image/jpeg;base64,${tag.image_url}`}
                          alt={tag.product_tag}
                          style={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                            objectFit: "contain"
                          }}
                          onError={(e) => {
                            console.error("Image load error for tag:", tag.product_tag);
                            setFailedImages(prev => ({
                              ...prev,
                              [tag.id]: true
                            }));
                          }}
                        />
                      ) : (
                        <Typography>
                          {tag.product_tag.charAt(0).toUpperCase() +
                            tag.product_tag.slice(1)}
                        </Typography>
                      )}
                    </div>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={styleState.blends[tag.product_tag] || false}
                          onChange={() =>
                            handleCheckboxChange("blends", tag.product_tag)
                          }
                          sx={{
                            color: "#565E6D",
                            "&.Mui-checked": { color: "#565E6D" },
                            "& .MuiSvgIcon-root": { fontSize: 22 },
                          }}
                        />
                      }
                      label={
                        tag.product_tag.charAt(0).toUpperCase() +
                        tag.product_tag.slice(1)
                      }
                    />
                  </div>
                );
              })}
              </div>

              {/* Create New Tag Button */}
              <Button
                startIcon={<AddCircleOutlineIcon />}
                sx={{
                  mt: 4.5,
                  width: 200,
                  height: 28,
                  border: "1px solid #ccc",
                  borderRadius: "0px",
                  backgroundColor: "white",
                  color: "black",
                  fontWeight: "bold",
                  "&:hover": { backgroundColor: "#b1b4b6" },
                }}
                onClick={() => setNewTagDialogOpen(true)}
              >
                Create New Tag
              </Button>

              {/* Save Changes Button */}
              <div
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Button
                  onClick={() => handleChevronClick("left")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  &lt; Previous
                </Button>
                <Button
                  onClick={async () => {
                    const selectedTags =
                      fabricTags["Blends"]
                        ?.filter((tag) => styleState.blends[tag.product_tag])
                        ?.map((tag) => tag.product_tag) || [];

                    const selectedIds =
                      fabricTags["Blends"]
                        ?.filter((tag) => styleState.blends[tag.product_tag])
                        ?.map((tag) => tag.id) || [];

                    await handleSubmit(selectedIds);
                  }}
                  sx={{
                    backgroundColor: "#565E6D",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#546e7a" },
                    borderRadius: "0px",
                  }}
                >
                  Save Changes
                </Button>
                <Button
                  onClick={() => handleChevronClick("right")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  Next &gt;
                </Button>
              </div>

              {/* Display Saved Tags */}
              <Box sx={{ mt: 4 }}>
                <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                  Saved Tag(s)
                </Typography>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    marginTop: "10px",
                  }}
                >
                  {(() => {
                    const apiTags = fabricTags["Blends"]?.filter(tag => tagIds.includes(tag.id));
                    if (apiTags && apiTags.length > 0) {
                      return apiTags.map(tag => (
                        <Chip
                          key={tag.id}
                          label={tag.product_tag}
                          sx={{
                            backgroundColor: "#565E6D",
                            color: "#fff",
                            borderRadius: "4px",
                          }}
                        />
                      ));
                    }
                    
                    return (
                      <Typography variant="body1">
                        No saved tags found.
                      </Typography>
                    );
                  })()}
                </div>
              </Box>
            </div>
          )}

          {/* Base color Section */}
          {selectedSection === "Base color" && (
            <div
              style={{
                marginTop: "20px",
                padding: "30px",
                backgroundColor: "#F3F4F6",
                borderRadius: "0px",
                borderTop: "2px solid #ccc",
              }}
            >
              {/* Base Color Section */}
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Base colour
              </Typography>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "start",
                  gap: "20px",
                  marginTop: "20px",
                }}
              >
                {/* None option as first radio */}
                <div style={{ textAlign: "start" }}>
                  <div
                    style={{
                      width: "60px",
                      height: "60px",
                      backgroundColor: "#ccc",
                      borderRadius: "100px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      border: Object.keys(baseColorState.baseColor).length === 0
                        ? "2px solid #565E6D"
                        : "2px solid transparent",
                    }}
                    onClick={() => {
                      // Deselect all base colors
                      setBaseColorState((prev) => ({
                        ...prev,
                        baseColor: {},
                      }));
                    }}
                  >
                    <Typography variant="body2" sx={{ color: "#565E6D" }}>
                      None
                    </Typography>
                  </div>
                  <FormControlLabel
                    control={
                      <Radio
                        checked={Object.keys(baseColorState.baseColor).length === 0}
                        onChange={() => {
                          setBaseColorState((prev) => ({
                            ...prev,
                            baseColor: {},
                          }));
                        }}
                        sx={{
                          color: "#565E6D",
                          "&.Mui-checked": { color: "#565E6D" },
                          "& .MuiSvgIcon-root": { fontSize: 20 },
                        }}
                      />
                    }
                    label="None"
                  />
                </div>
                {/* Actual base color options */}
                {fabricTags["Base color"]?.map((tag) => (
                  <div key={tag.id} style={{ textAlign: "start" }}>
                    <div
                      style={{
                        width: "60px",
                        height: "60px",
                        backgroundColor: getDisplayColor(tag.product_tag),
                        borderRadius: "100px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        border: baseColorState.baseColor[tag.product_tag]
                          ? "2px solid #565E6D"
                          : "2px solid transparent",
                      }}
                      onClick={() => {
                        // Only allow one selection
                        setBaseColorState((prev) => ({
                          ...prev,
                          baseColor: { [tag.product_tag]: true },
                        }));
                      }}
                    ></div>
                    <FormControlLabel
                      control={
                        <Radio
                          checked={!!baseColorState.baseColor[tag.product_tag]}
                          onChange={() => {
                            setBaseColorState((prev) => ({
                              ...prev,
                              baseColor: { [tag.product_tag]: true },
                            }));
                          }}
                          sx={{
                            color: "#565E6D",
                            "&.Mui-checked": { color: "#565E6D" },
                            "& .MuiSvgIcon-root": { fontSize: 20 },
                          }}
                        />
                      }
                      label={
                        tag.product_tag.charAt(0).toUpperCase() +
                        tag.product_tag.slice(1)
                      }
                    />
                  </div>
                ))}
              </div>
              <Button
                startIcon={<AddCircleOutlineIcon />}
                sx={{
                  mt: 2,
                  width: 200,
                  height: 28,
                  border: "1px solid #ccc",
                  borderRadius: "0px",
                  backgroundColor: "white",
                  color: "black",
                  fontWeight: "bold",
                  "&:hover": { backgroundColor: "#b1b4b6" },
                }}
                onClick={() => setNewTagDialogOpen(true)}
              >
                Create New Tag
              </Button>

              {/* Show Foreground Color Section only if any Base Color is checked */}
              {Object.values(baseColorState.baseColor).some(
                (checked) => checked
              ) && (
                <Box sx={{ mt: 4 }}>
                  <Typography
                    variant="body1"
                    sx={{
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 700,
                      fontSize: 16,
                    }}
                  >
                    Foreground colour
                  </Typography>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "start",
                      gap: "20px",
                      marginTop: "20px",
                    }}
                  >
                    {fabricTags["Foreground color"]?.map((tag) => (
                      <div key={tag.id} style={{ textAlign: "start" }}>
                        <div
                          style={{
                            width: "60px",
                            height: "60px",
                            backgroundColor: getDisplayColor(tag.product_tag),
                            borderRadius: "100px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            cursor: "pointer",
                            border: baseColorState.foregroundColor[
                              tag.product_tag
                            ]
                              ? "2px solid #565E6D"
                              : "2px solid transparent",
                          }}
                        ></div>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={
                                baseColorState.foregroundColor[
                                  tag.product_tag
                                ] || false
                              }
                              onChange={() =>
                                handleColorChange(
                                  "foregroundColor",
                                  tag.product_tag
                                )
                              }
                              sx={{
                                color: "#565E6D",
                                "&.Mui-checked": { color: "#565E6D" },
                                "& .MuiSvgIcon-root": { fontSize: 20 },
                              }}
                            />
                          }
                          label={
                            tag.product_tag.charAt(0).toUpperCase() +
                            tag.product_tag.slice(1)
                          }
                        />
                      </div>
                    ))}
                  </div>
                  {/* Create New Tag Button */}
                  <Button
                    startIcon={<AddCircleOutlineIcon />}
                    sx={{
                      mt: 4.5,
                      width: 200,
                      height: 28,
                      border: "1px solid #ccc",
                      borderRadius: "0px",
                      backgroundColor: "white",
                      color: "black",
                      fontWeight: "bold",
                      "&:hover": { backgroundColor: "#b1b4b6" },
                    }}
                    onClick={() => {
                      setSelectedSection("Foreground color");
                      setNewTagDialogOpen(true);
                    }}
                  >
                    Create New Tag
                  </Button>
                </Box>
              )}



              {/* Save Changes Button */}
              <div
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Button
                  onClick={() => handleChevronClick("left")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  &lt; Previous
                </Button>
                <Button
                  onClick={async () => {
                    // Collect base color tags
                    const baseColorIds = fabricTags["Base color"]
                      ?.filter((tag) => baseColorState.baseColor[tag.product_tag])
                        ?.map((tag) => tag.id) || [];

                    // Collect foreground color tags
                    const foregroundColorIds = fabricTags["Foreground color"]
                      ?.filter((tag) => baseColorState.foregroundColor[tag.product_tag])
                        ?.map((tag) => tag.id) || [];

                    // Collect background color tags
                    const backgroundColorIds = fabricTags["Background color"]
                      ?.filter((tag) => baseColorState.backgroundColor[tag.product_tag])
                        ?.map((tag) => tag.id) || [];

                    // Combine all color tag IDs
                    const allColorTagIds = [...baseColorIds, ...foregroundColorIds, ...backgroundColorIds];

                    await handleSubmitBaseColor(allColorTagIds);
                  }}
                  sx={{
                    backgroundColor: "#565E6D",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#546e7a" },
                    borderRadius: "0px",
                  }}
                >
                  Save Changes
                </Button>
                <Button
                  onClick={() => handleChevronClick("right")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  Next &gt;
                </Button>
              </div>

              {/* Display Saved Tags */}
              <Box sx={{ mt: 4 }}>
                <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                  Saved Tag(s)
                </Typography>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    marginTop: "10px",
                  }}
                >
                  {(() => {
                    const baseColorTags = fabricTags["Base color"]?.filter(tag => tagIds.includes(tag.id)) || [];
                    const foregroundColorTags = fabricTags["Foreground color"]?.filter(tag => tagIds.includes(tag.id)) || [];
                    const backgroundColorTags = fabricTags["Background color"]?.filter(tag => tagIds.includes(tag.id)) || [];

                    if (baseColorTags.length || foregroundColorTags.length || backgroundColorTags.length) {
                      return (
                        <React.Fragment>
                          {baseColorTags.map(tag => (
                            <Chip
                              key={`base-${tag.id}`}
                              label={tag.product_tag}
                              sx={{
                                backgroundColor: "#565E6D",
                                color: "#fff",
                                borderRadius: "4px",
                              }}
                            />
                          ))}
                          {foregroundColorTags.map(tag => (
                            <Chip
                              key={`fg-${tag.id}`}
                              label={`FG: ${tag.product_tag}`}
                              sx={{
                                backgroundColor: "#565E6D",
                                color: "#fff",
                                borderRadius: "4px",
                              }}
                            />
                          ))}
                          {backgroundColorTags.map(tag => (
                            <Chip
                              key={`bg-${tag.id}`}
                              label={`BG: ${tag.product_tag}`}
                              sx={{
                                backgroundColor: "#565E6D",
                                color: "#fff",
                                borderRadius: "4px",
                              }}
                            />
                          ))}
                        </React.Fragment>
                      );
                    }

                    return (
                      <Typography variant="body1">
                        No saved tags found.
                      </Typography>
                    );
                  })()}
                </div>
              </Box>
            </div>
          )}

          {/* Pattern Size Section */}
          {selectedSection === "Pattern size" && (
            <div
              style={{
                marginTop: "20px",
                padding: "10px",
                backgroundColor: "#F3F4F6",
                borderRadius: "0px",
                borderTop: "2px solid #ccc",
              }}
            >
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Pattern Size
              </Typography>
              <FormControl
                component="fieldset"
                sx={{
                  mt: 2,
                  padding: "10px 0",
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                }}
              >
          <RadioGroup
            row
            value={patternSize}
            onChange={(e) => setPatternSize(e.target.value)}
          >
            {/* None option */}
            <FormControlLabel
              value=""
              control={
                <Radio
                  sx={{
                    color: "black",
                    "&.Mui-checked": { color: "black" },
                  }}
                />
              }
              label="None"
            />
            {fabricTags["Pattern size"]?.map((tag) => (
              <FormControlLabel
                key={tag.id}
                value={tag.product_tag}
                control={
                  <Radio
                    sx={{
                      color: "black",
                      "&.Mui-checked": { color: "black" },
                    }}
                  />
                }
                label={
                  tag.product_tag.charAt(0).toUpperCase() +
                  tag.product_tag.slice(1)
                }
              />
            ))}
          </RadioGroup>

                {/* Create New Tag Button */}
                <Button
                  startIcon={<AddCircleOutlineIcon />}
                  sx={{
                    mt: 4.5,
                    width: 200,
                    height: 28,
                    border: "1px solid #ccc",
                    borderRadius: "0px",
                    backgroundColor: "white",
                    color: "black",
                    fontWeight: "bold",
                    "&:hover": { backgroundColor: "#b1b4b6" },
                  }}
                  onClick={() => setNewTagDialogOpen(true)}
                >
                  Create New Tag
                </Button>
              </FormControl>

              {/* Save Changes Button */}
              <div
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Button
                  onClick={() => handleChevronClick("left")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  &lt; Previous
                </Button>
                <Button
                  onClick={async () => {
                    const selectedTag = fabricTags["Pattern size"]?.find(
                      (tag) => tag.product_tag === patternSize
                    );
                    await handleSubmit(selectedTag ? [selectedTag.id] : []);
                  }}
                  sx={{
                    backgroundColor: "#565E6D",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#546e7a" },
                    borderRadius: "0px",
                  }}
                >
                  Save Changes
                </Button>
                <Button
                  onClick={() => handleChevronClick("right")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  Next &gt;
                </Button>
              </div>

              {/* Display Saved Tags */}
              <Box sx={{ mt: 4 }}>
                <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                  Saved Tag(s)
                </Typography>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    marginTop: "10px",
                  }}
                >
                  {(() => {
                    const apiTag = fabricTags["Pattern size"]?.find(tag => tagIds.includes(tag.id));
                    if (apiTag) {
                      return (
                        <Chip
                          key={apiTag.id}
                          label={apiTag.product_tag}
                          sx={{
                            backgroundColor: "#565E6D",
                            color: "#fff",
                            borderRadius: "4px",
                          }}
                        />
                      );
                    }
                    
                    return (
                      <Typography variant="body1">
                        No saved tags found.
                      </Typography>
                    );
                  })()}
                </div>
              </Box>
            </div>
          )}

          {/* Print Style Section */}
          {selectedSection === "Print style" && (
            <div
              style={{
                marginTop: "20px",
                padding: "10px",
                backgroundColor: "#F3F4F6",
                borderRadius: "0px",
                borderTop: "2px solid #ccc",
              }}
            >
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Print Style
              </Typography>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "start",
                  gap: "20px",
                  marginTop: "20px",
                }}
              >
                {fabricTags["Print style"]?.map((tag) => (
                  <div key={tag.id} style={{ textAlign: "start" }}>
                    <div
                      style={{
                        width: "122px",
                        height: "68px",
                        backgroundColor: "white",
                        borderRadius: "0px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        border: styleState.printStyle[tag.product_tag]
                          ? "2px solid #565E6D"
                          : "2px solid transparent",
                      }}
                      onClick={() =>
                        handleCheckboxChange("printStyle", tag.product_tag)
                      }
                    >
                      {tag.image_url && !tag.image_url.startsWith('blob:') ? (
                        <img
                          src={`data:image/jpeg;base64,${cleanBase64Data(tag.image_url)}`}
                          alt={tag.product_tag}
                          style={{
                            width: "120px",
                            height: "60px",
                            objectFit: "contain"
                          }}
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                        />
                      ) : (
                        <LandscapeIcon sx={{ color: "#BCC1CA", fontSize: 30 }} />
                      )}
                    </div>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={
                            styleState.printStyle[tag.product_tag] || false
                          }
                          onChange={() =>
                            handleCheckboxChange("printStyle", tag.product_tag)
                          }
                          sx={{
                            color: "#565E6D",
                            "&.Mui-checked": { color: "#565E6D" },
                            "& .MuiSvgIcon-root": { fontSize: 22 },
                          }}
                        />
                      }
                      label={
                        tag.product_tag.charAt(0).toUpperCase() +
                        tag.product_tag.slice(1)
                      }
                    />
                  </div>
                ))}
              </div>

              {/* Create New Tag Button */}
              <Button
                startIcon={<AddCircleOutlineIcon />}
                sx={{
                  mt: 4.5,
                  width: 200,
                  height: 28,
                  border: "1px solid #ccc",
                  borderRadius: "0px",
                  backgroundColor: "white",
                  color: "black",
                  fontWeight: "bold",
                  "&:hover": { backgroundColor: "#b1b4b6" },
                }}
                onClick={() => setNewTagDialogOpen(true)}
              >
                Create New Tag
              </Button>

              {/* Save Changes Button */}
              <div
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Button
                  onClick={() => handleChevronClick("left")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  &lt; Previous
                </Button>
                <Button
                  onClick={async () => {
                    const selectedTags =
                      fabricTags["Print style"]
                        ?.filter(
                          (tag) => styleState.printStyle[tag.product_tag]
                        )
                        ?.map((tag) => tag.product_tag) || [];

                    const selectedIds =
                      fabricTags["Print style"]
                        ?.filter(
                          (tag) => styleState.printStyle[tag.product_tag]
                        )
                        ?.map((tag) => tag.id) || [];
                    await handleSubmit(selectedIds);
                  }}
                  sx={{
                    backgroundColor: "#565E6D",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#546e7a" },
                    borderRadius: "0px",
                  }}
                >
                  Save Changes
                </Button>
                <Button
                  onClick={() => handleChevronClick("right")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  Next &gt;
                </Button>
              </div>

              {/* Display Saved Tags */}
              <Box sx={{ mt: 4 }}>
                <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                  Saved Tag(s)
                </Typography>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    marginTop: "10px",
                  }}
                >
                  {(() => {
                    const apiTags = fabricTags["Print style"]?.filter(tag => tagIds.includes(tag.id));
                    if (apiTags && apiTags.length > 0) {
                      return apiTags.map((tag, index) => (
                        <Chip
                          key={index}
                          label={tag.product_tag}
                          sx={{
                            backgroundColor: "#565E6D",
                            color: "#fff",
                            borderRadius: "4px",
                          }}
                        />
                      ));
                    }
                    
                    return (
                      <Typography variant="body1">
                        No saved tags found.
                      </Typography>
                    );
                  })()}
                </div>
              </Box>
            </div>
          )}

          {/* Pattern Section */}
          {selectedSection === "Pattern" && (
            <div
              style={{
                marginTop: "20px",
                padding: "10px",
                backgroundColor: "#F3F4F6",
                borderRadius: "0px",
                borderTop: "2px solid #ccc",
              }}
            >
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Pattern
              </Typography>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "start",
                  gap: "20px",
                  marginTop: "20px",
                }}
              >
                {fabricTags["Pattern"]?.map((tag) => (
                  <div key={tag.id} style={{ textAlign: "start" }}>
                    <div
                      style={{
                        width: "122px",
                        height: "68px",
                        backgroundColor: "white",
                        borderRadius: "0px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        border: styleState.pattern[tag.product_tag]
                          ? "2px solid #565E6D"
                          : "2px solid transparent",
                      }}
                      onClick={() =>
                        handleCheckboxChange("pattern", tag.product_tag)
                      }
                    >
                      {tag.image_url && !tag.image_url.startsWith('blob:') ? (
                        <img
                          src={`data:image/jpeg;base64,${cleanBase64Data(tag.image_url)}`}
                          alt={tag.product_tag}
                          style={{
                            width: "120px",
                            height: "60px",
                            objectFit: "contain"
                          }}
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                        />
                      ) : (
                        <LandscapeIcon sx={{ color: "#BCC1CA", fontSize: 30 }} />
                      )}
                    </div>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={styleState.pattern[tag.product_tag] || false}
                          onChange={() =>
                            handleCheckboxChange("pattern", tag.product_tag)
                          }
                          sx={{
                            color: "#565E6D",
                            "&.Mui-checked": { color: "#565E6D" },
                            "& .MuiSvgIcon-root": { fontSize: 22 },
                          }}
                        />
                      }
                      label={
                        tag.product_tag.charAt(0).toUpperCase() +
                        tag.product_tag.slice(1)
                      }
                    />
                  </div>
                ))}
              </div>

              {/* Create New Tag Button */}
              <Button
                startIcon={<AddCircleOutlineIcon />}
                sx={{
                  mt: 4.5,
                  width: 200,
                  height: 28,
                  border: "1px solid #ccc",
                  borderRadius: "0px",
                  backgroundColor: "white",
                  color: "black",
                  fontWeight: "bold",
                  "&:hover": { backgroundColor: "#b1b4b6" },
                }}
                onClick={() => setNewTagDialogOpen(true)}
              >
                Create New Tag
              </Button>

              {/* Save Changes Button */}
              <div
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Button
                  onClick={() => handleChevronClick("left")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  &lt; Previous
                </Button>
                <Button
                  onClick={async () => {
                    const selectedTags =
                      fabricTags["Pattern"]
                        ?.filter((tag) => styleState.pattern[tag.product_tag])
                        ?.map((tag) => tag.product_tag) || [];

                    const selectedIds =
                      fabricTags["Pattern"]
                        ?.filter((tag) => styleState.pattern[tag.product_tag])
                        ?.map((tag) => tag.id) || [];
                    await handleSubmit(selectedIds);
                  }}
                  sx={{
                    backgroundColor: "#565E6D",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#546e7a" },
                    borderRadius: "0px",
                  }}
                >
                  Save Changes
                </Button>
                <Button
                  onClick={() => handleChevronClick("right")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  Next &gt;
                </Button>
              </div>

              {/* Display Saved Tags */}
              <Box sx={{ mt: 4 }}>
                <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                  Saved Tag(s)
                </Typography>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    marginTop: "10px",
                  }}
                >
                  {(() => {
                    const apiTags = fabricTags["Pattern"]?.filter(tag => tagIds.includes(tag.id));
                    if (apiTags && apiTags.length > 0) {
                      return apiTags.map((tag, index) => (
                        <Chip
                          key={index}
                          label={tag.product_tag}
                          sx={{
                            backgroundColor: "#565E6D",
                            color: "#fff",
                            borderRadius: "4px",
                          }}
                        />
                      ));
                    }
                    
                    return (
                      <Typography variant="body1">
                        No saved tags found.
                      </Typography>
                    );
                  })()}
                </div>
              </Box>
            </div>
          )}

          {/* Character Section */}
          {selectedSection === "Character" && (
            <div
              style={{
                marginTop: "20px",
                padding: "10px",
                backgroundColor: "#F3F4F6",
                borderRadius: "0px",
                borderTop: "2px solid #ccc",
              }}
            >
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Character
              </Typography>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "start",
                  gap: "20px",
                  marginTop: "20px",
                }}
              >
                {fabricTags["Character"]?.map((tag) => (
                  <div key={tag.id} style={{ textAlign: "start" }}>
                    <div
                      style={{
                        width: "122px",
                        height: "68px",
                        backgroundColor: "white",
                        borderRadius: "0px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        border: styleState.character[tag.product_tag]
                          ? "2px solid #565E6D"
                          : "2px solid transparent",
                      }}
                      onClick={() =>
                        handleCheckboxChange("character", tag.product_tag)
                      }
                    >
                      {tag.image_url && !tag.image_url.startsWith('blob:') ? (
                        <img
                          src={`data:image/jpeg;base64,${cleanBase64Data(tag.image_url)}`}
                          alt={tag.product_tag}
                          style={{
                            width: "120px",
                            height: "60px",
                            objectFit: "contain"
                          }}
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                        />
                      ) : (
                        <LandscapeIcon sx={{ color: "#BCC1CA", fontSize: 30 }} />
                      )}
                    </div>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={
                            styleState.character[tag.product_tag] || false
                          }
                          onChange={() =>
                            handleCheckboxChange("character", tag.product_tag)
                          }
                          sx={{
                            color: "#565E6D",
                            "&.Mui-checked": { color: "#565E6D" },
                            "& .MuiSvgIcon-root": { fontSize: 22 },
                          }}
                        />
                      }
                      label={
                        tag.product_tag.charAt(0).toUpperCase() +
                        tag.product_tag.slice(1)
                      }
                    />
                  </div>
                ))}
              </div>

              {/* Create New Tag Button */}
              <Button
                startIcon={<AddCircleOutlineIcon />}
                sx={{
                  mt: 4.5,
                  width: 200,
                  height: 28,
                  border: "1px solid #ccc",
                  borderRadius: "0px",
                  backgroundColor: "white",
                  color: "black",
                  fontWeight: "bold",
                  "&:hover": { backgroundColor: "#b1b4b6" },
                }}
                onClick={() => setNewTagDialogOpen(true)}
              >
                Create New Tag
              </Button>

              {/* Save Changes Button */}
              <div
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Button
                  onClick={() => handleChevronClick("left")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  &lt; Previous
                </Button>
                <Button
                  onClick={async () => {
                    const selectedTags =
                      fabricTags["Character"]
                        ?.filter((tag) => styleState.character[tag.product_tag])
                        ?.map((tag) => tag.product_tag) || [];

                    const selectedIds =
                      fabricTags["Character"]
                        ?.filter((tag) => styleState.character[tag.product_tag])
                        ?.map((tag) => tag.id) || [];
                    await handleSubmit(selectedIds);
                  }}
                  sx={{
                    backgroundColor: "#565E6D",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#546e7a" },
                    borderRadius: "0px",
                  }}
                >
                  Save Changes
                </Button>
                <Button
                  onClick={() => handleChevronClick("right")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  Next &gt;
                </Button>
              </div>

              {/* Display Saved Tags */}
              <Box sx={{ mt: 4 }}>
                <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                  Saved Tag(s)
                </Typography>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    marginTop: "10px",
                  }}
                >
                  {(() => {
                    const apiTags = fabricTags["Character"]?.filter(tag => tagIds.includes(tag.id));
                    if (apiTags && apiTags.length > 0) {
                      return apiTags.map((tag, index) => (
                        <Chip
                          key={index}
                          label={tag.product_tag}
                          sx={{
                            backgroundColor: "#565E6D",
                            color: "#fff",
                            borderRadius: "4px",
                          }}
                        />
                      ));
                    }
                    
                    return (
                      <Typography variant="body1">
                        No saved tags found.
                      </Typography>
                    );
                  })()}
                </div>
              </Box>
            </div>
          )}

          {/* Weave Section */}
          {selectedSection === "Weave" && (
            <div
              style={{
                marginTop: "20px",
                padding: "10px",
                backgroundColor: "#F3F4F6",
                borderRadius: "0px",
                borderTop: "2px solid #ccc",
              }}
            >
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Weave
              </Typography>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "start",
                  gap: "20px",
                  marginTop: "20px",
                }}
              >
                {fabricTags["Weave"]?.map((tag) => (
                  <div key={tag.id} style={{ textAlign: "start" }}>
                    <div
                      style={{
                        width: "122px",
                        height: "68px",
                        backgroundColor: "white",
                        borderRadius: "0px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        border: styleState.weave[tag.product_tag]
                          ? "2px solid #565E6D"
                          : "2px solid transparent",
                      }}
                      onClick={() =>
                        handleCheckboxChange("weave", tag.product_tag)
                      }
                    >
                      {tag.image_url && !tag.image_url.startsWith('blob:') ? (
                        <img
                          src={`data:image/jpeg;base64,${cleanBase64Data(tag.image_url)}`}
                          alt={tag.product_tag}
                          style={{
                            width: "120px",
                            height: "60px",
                            objectFit: "contain"
                          }}
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                        />
                      ) : (
                        <LandscapeIcon sx={{ color: "#BCC1CA", fontSize: 30 }} />
                      )}
                    </div>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={styleState.weave[tag.product_tag] || false}
                          onChange={() =>
                            handleCheckboxChange("weave", tag.product_tag)
                          }
                          sx={{
                            color: "#565E6D",
                            "&.Mui-checked": { color: "#565E6D" },
                            "& .MuiSvgIcon-root": { fontSize: 22 },
                          }}
                        />
                      }
                      label={
                        tag.product_tag.charAt(0).toUpperCase() +
                        tag.product_tag.slice(1)
                      }
                    />
                  </div>
                ))}
              </div>

              {/* Create New Tag Button */}
              <Button
                startIcon={<AddCircleOutlineIcon />}
                sx={{
                  mt: 4.5,
                  width: 200,
                  height: 28,
                  border: "1px solid #ccc",
                  borderRadius: "0px",
                  backgroundColor: "white",
                  color: "black",
                  fontWeight: "bold",
                  "&:hover": { backgroundColor: "#b1b4b6" },
                }}
                onClick={() => setNewTagDialogOpen(true)}
              >
                Create New Tag
              </Button>

              {/* Save Changes Button */}
              <div
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Button
                  onClick={() => handleChevronClick("left")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  &lt; Previous
                </Button>
                <Button
                  onClick={async () => {
                    const selectedTags =
                      fabricTags["Weave"]
                        ?.filter((tag) => styleState.weave[tag.product_tag])
                        ?.map((tag) => tag.product_tag) || [];

                    const selectedIds =
                      fabricTags["Weave"]
                        ?.filter((tag) => styleState.weave[tag.product_tag])
                        ?.map((tag) => tag.id) || [];
                    await handleSubmit(selectedIds);
                  }}
                  sx={{
                    backgroundColor: "#565E6D",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#546e7a" },
                    borderRadius: "0px",
                  }}
                >
                  Save Changes
                </Button>
                <Button
                  onClick={() => handleChevronClick("right")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  Next &gt;
                </Button>
              </div>

              {/* Display Saved Tags */}
              <Box sx={{ mt: 4 }}>
                <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                  Saved Tag(s)
                </Typography>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    marginTop: "10px",
                  }}
                >
                  {(() => {
                    const apiTags = fabricTags["Weave"]?.filter(tag => tagIds.includes(tag.id));
                    if (apiTags && apiTags.length > 0) {
                      return apiTags.map((tag, index) => (
                        <Chip
                          key={index}
                          label={tag.product_tag}
                          sx={{
                            backgroundColor: "#565E6D",
                            color: "#fff",
                            borderRadius: "4px",
                          }}
                        />
                      ));
                    }
                    
                    return (
                      <Typography variant="body1">
                        No saved tags found.
                      </Typography>
                    );
                  })()}
                </div>
              </Box>
            </div>
          )}

          {/* Structure Section */}
          {selectedSection === "Structure" && (
            <div
              style={{
                marginTop: "20px",
                padding: "10px",
                backgroundColor: "#F3F4F6",
                borderRadius: "0px",
                borderTop: "2px solid #ccc",
              }}
            >
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Structure
              </Typography>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "start",
                  gap: "20px",
                  marginTop: "20px",
                }}
              >
                {fabricTags["Structure"]?.map((tag) => (
                  <div key={tag.id} style={{ textAlign: "start" }}>
                    <div
                      style={{
                        width: "122px",
                        height: "68px",
                        backgroundColor: "white",
                        borderRadius: "0px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        border: styleState.structure[tag.product_tag]
                          ? "2px solid #565E6D"
                          : "2px solid transparent",
                      }}
                      onClick={() =>
                        handleCheckboxChange("structure", tag.product_tag)
                      }
                    >
                      {tag.image_url && !tag.image_url.startsWith('blob:') ? (
                        <img 
                          src={`data:image/jpeg;base64,${cleanBase64Data(tag.image_url)}`}
                          alt={tag.product_tag}
                          style={{
                            width: "120px",
                            height: "60px",
                            objectFit: "contain"
                          }}
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                        />
                      ) : (
                        <LandscapeIcon sx={{ color: "#BCC1CA", fontSize: 30 }} />
                      )}
                    </div>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={
                            styleState.structure[tag.product_tag] || false
                          }
                          onChange={() =>
                            handleCheckboxChange("structure", tag.product_tag)
                          }
                          sx={{
                            color: "#565E6D",
                            "&.Mui-checked": { color: "#565E6D" },
                            "& .MuiSvgIcon-root": { fontSize: 22 },
                          }}
                        />
                      }
                      label={
                        tag.product_tag.charAt(0).toUpperCase() +
                        tag.product_tag.slice(1)
                      }
                    />
                  </div>
                ))}
              </div>

              {/* Create New Tag Button */}
              <Button
                startIcon={<AddCircleOutlineIcon />}
                sx={{
                  mt: 4.5,
                  width: 200,
                  height: 28,
                  border: "1px solid #ccc",
                  borderRadius: "0px",
                  backgroundColor: "white",
                  color: "black",
                  fontWeight: "bold",
                  "&:hover": { backgroundColor: "#b1b4b6" },
                }}
                onClick={() => setNewTagDialogOpen(true)}
              >
                Create New Tag
              </Button>

              {/* Save Changes Button */}
              <div
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Button
                  onClick={() => handleChevronClick("left")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  &lt; Previous
                </Button>
                <Button
                  onClick={async () => {
                    const selectedTags =
                      fabricTags["Structure"]
                        ?.filter((tag) => styleState.structure[tag.product_tag])
                        ?.map((tag) => tag.product_tag) || [];

                    const selectedIds =
                      fabricTags["Structure"]
                        ?.filter((tag) => styleState.structure[tag.product_tag])
                        ?.map((tag) => tag.id) || [];
                    await handleSubmit(selectedIds);
                  }}
                  sx={{
                    backgroundColor: "#565E6D",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#546e7a" },
                    borderRadius: "0px",
                  }}
                >
                  Save Changes
                </Button>
                <Button
                  onClick={() => handleChevronClick("right")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  Next &gt;
                </Button>
              </div>

              {/* Display Saved Tags */}
              <Box sx={{ mt: 4 }}>
                <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                  Saved Tag(s)
                </Typography>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    marginTop: "10px",
                  }}
                >
                  {(() => {
                    const apiTags = fabricTags["Structure"]?.filter(tag => tagIds.includes(tag.id));
                    if (apiTags && apiTags.length > 0) {
                      return apiTags.map((tag, index) => (
                        <Chip
                          key={index}
                          label={tag.product_tag}
                          sx={{
                            backgroundColor: "#565E6D",
                            color: "#fff",
                            borderRadius: "4px",
                          }}
                        />
                      ));
                    }
                    
                    return (
                      <Typography variant="body1">
                        No saved tags found.
                      </Typography>
                    );
                  })()}
                </div>
              </Box>
            </div>
          )}

          {/* Yarn property Section */}
          {selectedSection === "Yarn property" && (
            <div
              style={{
                marginTop: "20px",
                padding: "10px",
                backgroundColor: "#F3F4F6",
                borderRadius: "0px",
                borderTop: "2px solid #ccc",
              }}
            >
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Yarn Property
              </Typography>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "start",
                  gap: "20px",
                  marginTop: "20px",
                }}
              >
                {fabricTags["Yarn property"]?.map((tag) => (
                  <div key={tag.id} style={{ textAlign: "start" }}>
                    <div
                      style={{
                        width: "122px",
                        height: "68px",
                        backgroundColor: "white",
                        borderRadius: "0px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        border: styleState.yarnProperty[tag.product_tag]
                          ? "2px solid #565E6D"
                          : "2px solid transparent",
                      }}
                      onClick={() =>
                        handleCheckboxChange("yarnProperty", tag.product_tag)
                      }
                    >
                      {tag.image_url && !tag.image_url.startsWith('blob:') ? (
                        <img
                          src={`data:image/jpeg;base64,${cleanBase64Data(tag.image_url)}`}
                          alt={tag.product_tag}
                          style={{
                            width: "120px",
                            height: "60px",
                            objectFit: "contain"
                          }}
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                        />
                      ) : (
                        <LandscapeIcon sx={{ color: "#BCC1CA", fontSize: 30 }} />
                      )}
                    </div>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={
                            styleState.yarnProperty[tag.product_tag] || false
                          }
                          onChange={() =>
                            handleCheckboxChange(
                              "yarnProperty",
                              tag.product_tag
                            )
                          }
                          sx={{
                            color: "#565E6D",
                            "&.Mui-checked": { color: "#565E6D" },
                            "& .MuiSvgIcon-root": { fontSize: 22 },
                          }}
                        />
                      }
                      label={
                        tag.product_tag.charAt(0).toUpperCase() +
                        tag.product_tag.slice(1)
                      }
                    />
                  </div>
                ))}
              </div>

              {/* Create New Tag Button */}
              <Button
                startIcon={<AddCircleOutlineIcon />}
                sx={{
                  mt: 4.5,
                  width: 200,
                  height: 28,
                  border: "1px solid #ccc",
                  borderRadius: "0px",
                  backgroundColor: "white",
                  color: "black",
                  fontWeight: "bold",
                  "&:hover": { backgroundColor: "#b1b4b6" },
                }}
                onClick={() => setNewTagDialogOpen(true)}
              >
                Create New Tag
              </Button>

              {/* Save Changes Button */}
              <div
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Button
                  onClick={() => handleChevronClick("left")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  &lt; Previous
                </Button>
                <Button
                  onClick={async () => {
                    const selectedTags =
                      fabricTags["Yarn property"]
                        ?.filter(
                          (tag) => styleState.yarnProperty[tag.product_tag]
                        )
                        ?.map((tag) => tag.product_tag) || [];

                    const selectedIds =
                      fabricTags["Yarn property"]
                        ?.filter(
                          (tag) => styleState.yarnProperty[tag.product_tag]
                        )
                        ?.map((tag) => tag.id) || [];
                    await handleSubmit(selectedIds);
                  }}
                  sx={{
                    backgroundColor: "#565E6D",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#546e7a" },
                    borderRadius: "0px",
                  }}
                >
                  Save Changes
                </Button>
                <Button
                  onClick={() => handleChevronClick("right")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  Next &gt;
                </Button>
              </div>

              {/* Display Saved Tags */}
              <Box sx={{ mt: 4 }}>
                <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                  Saved Tag(s)
                </Typography>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    marginTop: "10px",
                  }}
                >
                  {(() => {
                    const apiTags = fabricTags["Yarn property"]?.filter(tag => tagIds.includes(tag.id));
                    if (apiTags && apiTags.length > 0) {
                      return apiTags.map((tag, index) => (
                        <Chip
                          key={index}
                          label={tag.product_tag}
                          sx={{
                            backgroundColor: "#565E6D",
                            color: "#fff",
                            borderRadius: "4px",
                          }}
                        />
                      ));
                    }
                    
                    return (
                      <Typography variant="body1">
                        No saved tags found.
                      </Typography>
                    );
                  })()}
                </div>
              </Box>
            </div>
          )}

          {/* Fabric Finish Section */}
          {selectedSection === "Fabric Finish" && (
            <div
              style={{
                marginTop: "20px",
                padding: "10px",
                backgroundColor: "#F3F4F6",
                borderRadius: "0px",
                borderTop: "2px solid #ccc",
              }}
            >
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Fabric Finish
              </Typography>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "start",
                  gap: "20px",
                  marginTop: "20px",
                }}
              >
                {fabricTags["Fabric Finish"]?.map((tag) => (
                  <div key={tag.id} style={{ textAlign: "start" }}>
                    <div
                      style={{
                        width: "122px",
                        height: "68px",
                        backgroundColor: "white",
                        borderRadius: "0px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        border: styleState.fabricFinish[tag.product_tag]
                          ? "2px solid #565E6D"
                          : "2px solid transparent",
                      }}
                      onClick={() =>
                        handleCheckboxChange("fabricFinish", tag.product_tag)
                      }
                    >
                      {tag.image_url && !tag.image_url.startsWith('blob:') ? (
                        <img
                          src={`data:image/jpeg;base64,${cleanBase64Data(tag.image_url)}`}
                          alt={tag.product_tag}
                          style={{
                            width: "120px",
                            height: "60px",
                            objectFit: "contain"
                          }}
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                        />
                      ) : (
                        <LandscapeIcon sx={{ color: "#BCC1CA", fontSize: 30 }} />
                      )}
                    </div>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={
                            styleState.fabricFinish[tag.product_tag] || false
                          }
                          onChange={() =>
                            handleCheckboxChange(
                              "fabricFinish",
                              tag.product_tag
                            )
                          }
                          sx={{
                            color: "#565E6D",
                            "&.Mui-checked": { color: "#565E6D" },
                            "& .MuiSvgIcon-root": { fontSize: 22 },
                          }}
                        />
                      }
                      label={
                        tag.product_tag.charAt(0).toUpperCase() +
                        tag.product_tag.slice(1)
                      }
                    />
                  </div>
                ))}
              </div>

              {/* Create New Tag Button */}
              <Button
                startIcon={<AddCircleOutlineIcon />}
                sx={{
                  mt: 4.5,
                  width: 200,
                  height: 28,
                  border: "1px solid #ccc",
                  borderRadius: "0px",
                  backgroundColor: "white",
                  color: "black",
                  fontWeight: "bold",
                  "&:hover": { backgroundColor: "#b1b4b6" },
                }}
                onClick={() => setNewTagDialogOpen(true)}
              >
                Create New Tag
              </Button>

              {/* Save Changes Button */}
              <div
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Button
                  onClick={() => handleChevronClick("left")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  &lt; Previous
                </Button>
                <Button
                  onClick={async () => {
                    const selectedTags =
                      fabricTags["Fabric Finish"]
                        ?.filter(
                          (tag) => styleState.fabricFinish[tag.product_tag]
                        )
                        ?.map((tag) => tag.product_tag) || [];

                    const selectedIds =
                      fabricTags["Fabric Finish"]
                        ?.filter(
                          (tag) => styleState.fabricFinish[tag.product_tag]
                        )
                        ?.map((tag) => tag.id) || [];
                    await handleSubmit(selectedIds);
                  }}
                  sx={{
                    backgroundColor: "#565E6D",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#546e7a" },
                    borderRadius: "0px",
                  }}
                >
                  Save Changes
                </Button>
                <Button
                  onClick={() => handleChevronClick("right")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  Next &gt;
                </Button>
              </div>

              {/* Display Saved Tags */}
              <Box sx={{ mt: 4 }}>
                <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                  Saved Tag(s)
                </Typography>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    marginTop: "10px",
                  }}
                >
                  {(() => {
                    const apiTags = fabricTags["Fabric Finish"]?.filter(tag => tagIds.includes(tag.id));
                    if (apiTags && apiTags.length > 0) {
                      return apiTags.map((tag, index) => (
                        <Chip
                          key={index}
                          label={tag.product_tag}
                          sx={{
                            backgroundColor: "#565E6D",
                            color: "#fff",
                            borderRadius: "4px",
                          }}
                        />
                      ));
                    }
                    
                    return (
                      <Typography variant="body1">
                        No saved tags found.
                      </Typography>
                    );
                  })()}
                </div>
              </Box>
            </div>
          )}

          {/* Season Section */}
          {selectedSection === "Season" && (
            <div
              style={{
                marginTop: "20px",
                padding: "10px",
                backgroundColor: "#F3F4F6",
                borderRadius: "0px",
                borderTop: "2px solid #ccc",
              }}
            >
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Season
              </Typography>
              <FormControl
                component="fieldset"
                sx={{
                  mt: 2,
                  padding: "10px 0",
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                }}
              >
          <RadioGroup
            row
            value={season}
            onChange={(e) => setSeason(e.target.value)}
          >
            {/* None option */}
            <FormControlLabel
              value=""
              control={
                <Radio
                  sx={{
                    color: "black",
                    "&.Mui-checked": { color: "black" },
                  }}
                />
              }
              label="None"
            />
            {fabricTags["Season"]?.map((tag) => (
              <FormControlLabel
                key={tag.id}
                value={tag.product_tag}
                control={
                  <Radio
                    sx={{
                      color: "black",
                      "&.Mui-checked": { color: "black" },
                    }}
                  />
                }
                label={
                  tag.product_tag.charAt(0).toUpperCase() +
                  tag.product_tag.slice(1)
                }
              />
            ))}
          </RadioGroup>

                {/* Create New Tag Button */}
                <Button
                  startIcon={<AddCircleOutlineIcon />}
                  sx={{
                    mt: 4.5,
                    width: 200,
                    height: 28,
                    border: "1px solid #ccc",
                    borderRadius: "0px",
                    backgroundColor: "white",
                    color: "black",
                    fontWeight: "bold",
                    "&:hover": { backgroundColor: "#b1b4b6" },
                  }}
                  onClick={() => setNewTagDialogOpen(true)}
                >
                  Create New Tag
                </Button>
              </FormControl>

              {/* Save Changes Button */}
              <div
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Button
                  onClick={() => handleChevronClick("left")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  &lt; Previous
                </Button>
                <Button
                  onClick={async () => {
                    const selectedTag = fabricTags["Season"]?.find(
                      (tag) => tag.product_tag === season
                    );
                    await handleSubmit(selectedTag ? [selectedTag.id] : []);                    
                  }}
                  sx={{
                    backgroundColor: "#565E6D",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#546e7a" },
                    borderRadius: "0px",
                  }}
                >
                  Save Changes
                </Button>
                <Button
                  onClick={() => handleChevronClick("right")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  Next &gt;
                </Button>
              </div>

              {/* Display Saved Tags */}
              <Box sx={{ mt: 4 }}>
                <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                  Saved Tag(s)
                </Typography>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    marginTop: "10px",
                  }}
                >
                  {(() => {
                    const apiTag = fabricTags["Season"]?.find(tag => tagIds.includes(tag.id));
                    if (apiTag) {
                      return (
                        <Chip
                          key={apiTag.id}
                          label={apiTag.product_tag}
                          sx={{
                            backgroundColor: "#565E6D",
                            color: "#fff",
                            borderRadius: "4px",
                          }}
                        />
                      );
                    }
                    
                    return (
                      <Typography variant="body1">
                        No saved tags found.
                      </Typography>
                    );
                  })()}
                </div>
              </Box>
            </div>
          )}

          {/* Category Section */}
          {selectedSection === "Category" && (
            <div
              style={{
                marginTop: "20px",
                padding: "10px",
                backgroundColor: "#F3F4F6",
                borderRadius: "0px",
                borderTop: "2px solid #ccc",
              }}
            >
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Category
              </Typography>
              <FormControl
                component="fieldset"
                sx={{
                  mt: 2,
                  padding: "10px 0",
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                }}
              >
            {/* Category section with checkboxes for multiple selection */}
            <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 2 }}>
              {fabricTags["Category"]?.map((tag) => (
                <FormControlLabel
                  key={tag.id}
                  control={
                    <Checkbox
                      checked={category.includes(tag.product_tag)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setCategory([...category, tag.product_tag]);
                        } else {
                          setCategory(category.filter((c) => c !== tag.product_tag));
                        }
                      }}
                      sx={{ color: "#565E6D", '&.Mui-checked': { color: '#565E6D' } }}
                    />
                  }
                  label={tag.product_tag.charAt(0).toUpperCase() + tag.product_tag.slice(1)}
                />
              ))}
            </Box>

                {/* Create New Tag Button */}
                <Button
                  startIcon={<AddCircleOutlineIcon />}
                  sx={{
                    mt: 4.5,
                    width: 200,
                    height: 28,
                    border: "1px solid #ccc",
                    borderRadius: "0px",
                    backgroundColor: "white",
                    color: "black",
                    fontWeight: "bold",
                    "&:hover": { backgroundColor: "#b1b4b6" },
                  }}
                  onClick={() => setNewTagDialogOpen(true)}
                >
                  Create New Tag
                </Button>
              </FormControl>

              {/* Save Changes Button */}
              <div
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Button
                  onClick={() => handleChevronClick("left")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  &lt; Previous
                </Button>
                <Button
                  onClick={async () => {
                    // Collect all selected category tag IDs for submission
                    const selectedTags = fabricTags["Category"]?.filter(
                      (tag) => category.includes(tag.product_tag)
                    ) || [];
                    await handleSubmit(selectedTags.map(tag => tag.id));
                  }}
                  sx={{
                    backgroundColor: "#565E6D",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#546e7a" },
                    borderRadius: "0px",
                  }}
                >
                  Save Changes
                </Button>
                <Button
                  onClick={() => handleChevronClick("right")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  Next &gt;
                </Button>
              </div>

              {/* Display Saved Tags */}
              <Box sx={{ mt: 4 }}>
                <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                  Saved Tag(s)
                </Typography>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    marginTop: "10px",
                  }}
                >
                  {(() => {
                    const apiTag = fabricTags["Category"]?.find(tag => tagIds.includes(tag.id));
                    if (apiTag) {
                      return (
                        <Chip
                          key={apiTag.id}
                          label={apiTag.product_tag}
                          sx={{
                            backgroundColor: "#565E6D",
                            color: "#fff",
                            borderRadius: "4px",
                          }}
                        />
                      );
                    }
                    
                    return (
                      <Typography variant="body1">
                        No saved tags found.
                      </Typography>
                    );
                  })()}
                </div>
              </Box>
            </div>
          )}

          {/* Style Section */}
          {selectedSection === "Style" && (
            <div
              style={{
                marginTop: "20px",
                padding: "10px",
                backgroundColor: "#F3F4F6",
                borderRadius: "0px",
                borderTop: "2px solid #ccc",
              }}
            >
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Style
              </Typography>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "start",
                  gap: "20px",
                  marginTop: "20px",
                }}
              >
                {fabricTags["Style"]?.map((tag) => (
                  <div key={tag.id} style={{ textAlign: "start" }}>
                    <div
                      style={{
                        width: "122px",
                        height: "68px",
                        backgroundColor: "white",
                        borderRadius: "0px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        border: styleState.style[tag.product_tag]
                          ? "2px solid #565E6D"
                          : "2px solid transparent",
                      }}
                      onClick={() =>
                        handleCheckboxChange("style", tag.product_tag)
                      }
                    >
                      {tag.image_url && !tag.image_url.startsWith('blob:') ? (
                        <img
                          src={`data:image/jpeg;base64,${cleanBase64Data(tag.image_url)}`}
                          alt={tag.product_tag}
                          style={{
                            width: "120px",
                            height: "60px",
                            objectFit: "contain"
                          }}
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                        />
                      ) : (
                        <LandscapeIcon sx={{ color: "#BCC1CA", fontSize: 30 }} />
                      )}
                    </div>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={styleState.style[tag.product_tag] || false}
                          onChange={() =>
                            handleCheckboxChange("style", tag.product_tag)
                          }
                          sx={{
                            color: "#565E6D",
                            "&.Mui-checked": { color: "#565E6D" },
                            "& .MuiSvgIcon-root": { fontSize: 22 },
                          }}
                        />
                      }
                      label={
                        tag.product_tag.charAt(0).toUpperCase() +
                        tag.product_tag.slice(1)
                      }
                    />
                  </div>
                ))}
              </div>

              {/* Create New Tag Button */}
              <Button
                startIcon={<AddCircleOutlineIcon />}
                sx={{
                  mt: 4.5,
                  width: 200,
                  height: 28,
                  border: "1px solid #ccc",
                  borderRadius: "0px",
                  backgroundColor: "white",
                  color: "black",
                  fontWeight: "bold",
                  "&:hover": { backgroundColor: "#b1b4b6" },
                }}
                onClick={() => setNewTagDialogOpen(true)}
              >
                Create New Tag
              </Button>

              {/* Save Changes Button */}
              <div
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Button
                  onClick={() => handleChevronClick("left")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  &lt; Previous
                </Button>
                <Button
                  onClick={async () => {
                    const selectedTags =
                      fabricTags["Style"]
                        ?.filter((tag) => styleState.style[tag.product_tag])
                        ?.map((tag) => tag.product_tag) || [];

                    const selectedIds =
                      fabricTags["Style"]
                        ?.filter((tag) => styleState.style[tag.product_tag])
                        ?.map((tag) => tag.id) || [];
                    await handleSubmit(selectedIds);
                  }}
                  sx={{
                    backgroundColor: "#565E6D",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#546e7a" },
                    borderRadius: "0px",
                  }}
                >
                  Save Changes
                </Button>
                <Button
                  onClick={() => handleChevronClick("right")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  Next &gt;
                </Button>
              </div>

              {/* Display Saved Tags */}
              <Box sx={{ mt: 4 }}>
                <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                  Saved Tag(s)
                </Typography>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    marginTop: "10px",
                  }}
                >
                  {(() => {
                    const apiTags = fabricTags["Style"]?.filter(tag => tagIds.includes(tag.id));
                    if (apiTags && apiTags.length > 0) {
                      return apiTags.map((tag, index) => (
                        <Chip
                          key={index}
                          label={tag.product_tag}
                          sx={{
                            backgroundColor: "#565E6D",
                            color: "#fff",
                            borderRadius: "4px",
                          }}
                        />
                      ));
                    }
                    
                    return (
                      <Typography variant="body1">
                        No saved tags found.
                      </Typography>
                    );
                  })()}
                </div>
              </Box>
            </div>
          )}

          {/* Denim Section */}
          {selectedSection === "Denim" && (
            <div
              style={{
                marginTop: "20px",
                padding: "10px",
                backgroundColor: "#F3F4F6",
                borderRadius: "0px",
                borderTop: "2px solid #ccc",
              }}
            >
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Denim
              </Typography>
              <FormControl
                component="fieldset"
                sx={{
                  mt: 2,
                  padding: "10px 0",
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                }}
              >
          <RadioGroup
            row
            value={denim}
            onChange={(e) => setDenim(e.target.value)}
          >
            {/* None option */}
            <FormControlLabel
              value=""
              control={
                <Radio
                  sx={{
                    color: "black",
                    "&.Mui-checked": { color: "black" },
                  }}
                />
              }
              label="None"
            />
            {fabricTags["Denim"]?.map((tag) => (
              <FormControlLabel
                key={tag.id}
                value={tag.product_tag}
                control={
                  <Radio
                    sx={{
                      color: "black",
                      "&.Mui-checked": { color: "black" },
                    }}
                  />
                }
                label={
                  tag.product_tag.charAt(0).toUpperCase() +
                  tag.product_tag.slice(1)
                }
              />
            ))}
          </RadioGroup>

                {/* Create New Tag Button */}
                <Button
                  startIcon={<AddCircleOutlineIcon />}
                  sx={{
                    mt: 4.5,
                    width: 200,
                    height: 28,
                    border: "1px solid #ccc",
                    borderRadius: "0px",
                    backgroundColor: "white",
                    color: "black",
                    fontWeight: "bold",
                    "&:hover": { backgroundColor: "#b1b4b6" },
                  }}
                  onClick={() => setNewTagDialogOpen(true)}
                >
                  Create New Tag
                </Button>
              </FormControl>

              {/* Save Changes & Chevron Buttons */}
              <div
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Button
                  onClick={() => handleChevronClick("left")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  &lt; Previous
                </Button>
                <Button
                  onClick={async () => {
                    const selectedTag = fabricTags["Denim"]?.find(
                      (tag) => tag.product_tag === denim
                    );
                    await handleSubmit(selectedTag ? [selectedTag.id] : []);
                  }}
                  sx={{
                    backgroundColor: "#565E6D",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#546e7a" },
                    borderRadius: "0px",
                  }}
                >
                  Save Changes
                </Button>
                <Button
                  onClick={() => handleChevronClick("right")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  Next &gt;
                </Button>
              </div>

              {/* Display Saved Tags */}
              <Box sx={{ mt: 4 }}>
                <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                  Saved Tag(s)
                </Typography>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    marginTop: "10px",
                  }}
                >
                  {(() => {
                    const apiTag = fabricTags["Denim"]?.find(tag => tagIds.includes(tag.id));
                    if (apiTag) {
                      return (
                        <Chip
                          key={apiTag.id}
                          label={apiTag.product_tag}
                          sx={{
                            backgroundColor: "#565E6D",
                            color: "#fff",
                            borderRadius: "4px",
                          }}
                        />
                      );
                    }
                    
                    return (
                      <Typography variant="body1">
                        No saved tags found.
                      </Typography>
                    );
                  })()}
                </div>
              </Box>
            </div>
          )}

          {/* Sustainability Section */}
          {selectedSection === "Sustainability" && (
            <div
              style={{
                marginTop: "20px",
                padding: "10px",
                backgroundColor: "#F3F4F6",
                borderRadius: "0px",
                borderTop: "2px solid #ccc",
              }}
            >
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Sustainability
              </Typography>
              <FormControl
                component="fieldset"
                sx={{
                  mt: 2,
                  padding: "10px 0",
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                }}
              >
          <RadioGroup
            row
            value={sustainability}
            onChange={(e) => setSustainability(e.target.value)}
          >
            {/* None option */}
            <FormControlLabel
              value=""
              control={
                <Radio
                  sx={{
                    color: "black",
                    "&.Mui-checked": { color: "black" },
                  }}
                />
              }
              label="None"
            />
            {fabricTags["Sustainability"]?.map((tag) => (
              <FormControlLabel
                key={tag.id}
                value={tag.product_tag}
                control={
                  <Radio
                    sx={{
                      color: "black",
                      "&.Mui-checked": { color: "black" },
                    }}
                  />
                }
                label={
                  tag.product_tag.charAt(0).toUpperCase() +
                  tag.product_tag.slice(1)
                }
              />
            ))}
          </RadioGroup>

                {/* Create New Tag Button */}
                <Button
                  startIcon={<AddCircleOutlineIcon />}
                  sx={{
                    mt: 4.5,
                    width: 200,
                    height: 28,
                    border: "1px solid #ccc",
                    borderRadius: "0px",
                    backgroundColor: "white",
                    color: "black",
                    fontWeight: "bold",
                    "&:hover": { backgroundColor: "#b1b4b6" },
                  }}
                  onClick={() => setNewTagDialogOpen(true)}
                >
                  Create New Tag
                </Button>
              </FormControl>

              {/* Save Changes Button */}
              <div
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Button
                  onClick={() => handleChevronClick("left")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  &lt; Previous
                </Button>
                <Button
                  onClick={async () => {
                    const selectedTag = fabricTags["Sustainability"]?.find(
                      (tag) => tag.product_tag === sustainability
                    );
                    await handleSubmit(selectedTag ? [selectedTag.id] : []);
                  }}
                  sx={{
                    backgroundColor: "#565E6D",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#546e7a" },
                    borderRadius: "0px",
                  }}
                >
                  Save Changes
                </Button>
                <Button
                  onClick={() => handleChevronClick("right")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  Next &gt;
                </Button>
              </div>

              {/* Display Saved Tags */}
              <Box sx={{ mt: 4 }}>
                <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                  Saved Tag(s)
                </Typography>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    marginTop: "10px",
                  }}
                >
                  {(() => {
                    const apiTag = fabricTags["Sustainability"]?.find(tag => tagIds.includes(tag.id));
                    if (apiTag) {
                      return (
                        <Chip
                          key={apiTag.id}
                          label={apiTag.product_tag}
                          sx={{
                            backgroundColor: "#565E6D",
                            color: "#fff",
                            borderRadius: "4px",
                          }}
                        />
                      );
                    }
                    
                    return (
                      <Typography variant="body1">
                        No saved tags found.
                      </Typography>
                    );
                  })()}
                </div>
              </Box>
            </div>
          )}

          {/* Dye technique Section */}
          {selectedSection === "Dye technique" && (
            <div
              style={{
                marginTop: "20px",
                padding: "10px",
                backgroundColor: "#F3F4F6",
                borderRadius: "0px",
                borderTop: "2px solid #ccc",
              }}
            >
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Dye technique
              </Typography>
              <FormControl
                component="fieldset"
                sx={{
                  mt: 2,
                  padding: "10px 0",
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                }}
              >
          <RadioGroup
            row
            value={dyeTechnique}
            onChange={(e) => setDyeTechnique(e.target.value)}
          >
            {/* None option */}
            <FormControlLabel
              value=""
              control={
                <Radio
                  sx={{
                    color: "black",
                    "&.Mui-checked": { color: "black" },
                  }}
                />
              }
              label="None"
            />
            {fabricTags["Dye technique"]?.map((tag) => (
              <FormControlLabel
                key={tag.id}
                value={tag.product_tag}
                control={
                  <Radio
                    sx={{
                      color: "black",
                      "&.Mui-checked": { color: "black" },
                    }}
                  />
                }
                label={
                  tag.product_tag.charAt(0).toUpperCase() +
                  tag.product_tag.slice(1)
                }
              />
            ))}
          </RadioGroup>

                {/* Create New Tag Button */}
                <Button
                  startIcon={<AddCircleOutlineIcon />}
                  sx={{
                    mt: 4.5,
                    width: 200,
                    height: 28,
                    border: "1px solid #ccc",
                    borderRadius: "0px",
                    backgroundColor: "white",
                    color: "black",
                    fontWeight: "bold",
                    "&:hover": { backgroundColor: "#b1b4b6" },
                  }}
                  onClick={() => setNewTagDialogOpen(true)}
                >
                  Create New Tag
                </Button>
              </FormControl>

              {/* Save Changes Button */}
              <div
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Button
                  onClick={() => handleChevronClick("left")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  &lt; Previous
                </Button>
                <Button
                  onClick={async () => {
                    const selectedTag = fabricTags["Dye technique"]?.find(
                      (tag) => tag.product_tag === dyeTechnique
                    );
                    await handleSubmit(selectedTag ? [selectedTag.id] : []);
                  }}
                  sx={{
                    backgroundColor: "#565E6D",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#546e7a" },
                    borderRadius: "0px",
                  }}
                >
                  Save Changes
                </Button>
                <Button
                  onClick={() => handleChevronClick("right")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  Next &gt;
                </Button>
              </div>

              {/* Display Saved Tags */}
              <Box sx={{ mt: 4 }}>
                <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                  Saved Tag(s)
                </Typography>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    marginTop: "10px",
                  }}
                >
                  {(() => {
                    const apiTag = fabricTags["Dye technique"]?.find(tag => tagIds.includes(tag.id));
                    if (apiTag) {
                      return (
                        <Chip
                          key={apiTag.id}
                          label={apiTag.product_tag}
                          sx={{
                            backgroundColor: "#565E6D",
                            color: "#fff",
                            borderRadius: "4px",
                          }}
                        />
                      );
                    }
                    
                    return (
                      <Typography variant="body1">
                        No saved tags found.
                      </Typography>
                    );
                  })()}
                </div>
              </Box>
            </div>
          )}

          {/* Dye used Section */}
          {selectedSection === "Dye used" && (
            <div
              style={{
                marginTop: "20px",
                padding: "10px",
                backgroundColor: "#F3F4F6",
                borderRadius: "0px",
                borderTop: "2px solid #ccc",
              }}
            >
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Dye used
              </Typography>
              <FormControl
                component="fieldset"
                sx={{
                  mt: 2,
                  padding: "10px 0",
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                }}
              >
          <RadioGroup
            row
            value={dyeUsed}
            onChange={(e) => setDyeUsed(e.target.value)}
          >
            {/* None option */}
            <FormControlLabel
              value=""
              control={
                <Radio
                  sx={{
                    color: "black",
                    "&.Mui-checked": { color: "black" },
                  }}
                />
              }
              label="None"
            />
            {fabricTags["Dye used"]?.map((tag) => (
              <FormControlLabel
                key={tag.id}
                value={tag.product_tag}
                control={
                  <Radio
                    sx={{
                      color: "black",
                      "&.Mui-checked": { color: "black" },
                    }}
                  />
                }
                label={
                  tag.product_tag.charAt(0).toUpperCase() +
                  tag.product_tag.slice(1)
                }
              />
            ))}
          </RadioGroup>

                {/* Create New Tag Button */}
                <Button
                  startIcon={<AddCircleOutlineIcon />}
                  sx={{
                    mt: 4.5,
                    width: 200,
                    height: 28,
                    border: "1px solid #ccc",
                    borderRadius: "0px",
                    backgroundColor: "white",
                    color: "black",
                    fontWeight: "bold",
                    "&:hover": { backgroundColor: "#b1b4b6" },
                  }}
                  onClick={() => setNewTagDialogOpen(true)}
                >
                  Create New Tag
                </Button>
              </FormControl>

              {/* Save Changes Button */}
              <div
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Button
                  onClick={() => handleChevronClick("left")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  &lt; Previous
                </Button>
                <Button
                  onClick={async () => {
                    const selectedTag = fabricTags["Dye used"]?.find(
                      (tag) => tag.product_tag === dyeUsed
                    );
                    await handleSubmit(selectedTag ? [selectedTag.id] : []);
                  }}
                  sx={{
                    backgroundColor: "#565E6D",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#546e7a" },
                    borderRadius: "0px",
                  }}
                >
                  Save Changes
                </Button>
                <Button
                  onClick={() => handleChevronClick("right")}
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#565E6D",
                    "&:hover": { backgroundColor: "#F3F4F6" },
                    borderRadius: "0px",
                    px: 2,
                    py: 1,
                    fontWeight: "bold",
                  }}
                >
                  Next &gt;
                </Button>
              </div>

              {/* Display Saved Tags */}
              <Box sx={{ mt: 4 }}>
                <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                  Saved Tag(s)
                </Typography>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    marginTop: "10px",
                  }}
                >
                  {(() => {
                    const apiTag = fabricTags["Dye used"]?.find(tag => tagIds.includes(tag.id));
                    if (apiTag) {
                      return (
                        <Chip
                          key={apiTag.id}
                          label={apiTag.product_tag}
                          sx={{
                            backgroundColor: "#565E6D",
                            color: "#fff",
                            borderRadius: "4px",
                          }}
                        />
                      );
                    }
                    
                    return (
                      <Typography variant="body1">
                        No saved tags found.
                      </Typography>
                    );
                  })()}
                </div>
              </Box>
            </div>
          )}
        </AccordionDetails>
      </Accordion>

      <Dialog
        open={newTagDialogOpen}
        onClose={() => setNewTagDialogOpen(false)}
        fullWidth
        maxWidth="sm"
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "0px",
            backgroundColor: "#F3F4F6",
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: "#565E6D",
            color: "#fff",
            fontWeight: "bold",
            fontSize: "1rem",
            padding: "16px 24px",
          }}
        >
          Create New Tag for {selectedSection}
        </DialogTitle>

        <DialogContent sx={{ padding: "24px" }}>
          <Grid container spacing={2}>
            <Grid item xs={12} mt={2}>
              <TextField
                fullWidth
                label="Tag Name"
                value={newTagData.product_tag}
                onChange={(e) =>
                  setNewTagData((prev) => ({
                    ...prev,
                    product_tag: e.target.value,
                  }))
                }
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "0px",
                    backgroundColor: "#fff",
                    "& fieldset": {
                      borderColor: "#BCC1CA",
                    },
                  },
                }}
              />
            </Grid>

            {/* Image upload section */}
            {!["Fabric composition", "Fabric Category", "Base color", 
               "Foreground color", "Background color", "Pattern size",
               "Season", "Category", "Denim", "Sustainability",
               "Dye technique", "Dye used"].includes(selectedSection) && (
              <Grid item xs={12}>
                <Box
                  sx={{
                    mt: 2,
                    width: 120,
                    height: 60,
                    border: "1px solid #BCC1CA",
                    backgroundColor: "#FAFAFB",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    "&:hover": {
                      borderColor: "#565E6D",
                    },
                  }}
                >
                  {tagImageUrl ? (
                    <img
                      src={tagImageUrl}
                      alt="Preview"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain"
                      }}
                    />
                  ) : (
                    <LandscapeIcon sx={{ color: "#BCC1CA" }} />
                  )}
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mt: 1,
                    gap: 1,
                  }}
                >
                  <label
                    htmlFor="tag-image-upload"
                    style={{ cursor: "pointer" }}
                  >
                    <input
                      accept="image/*"
                      type="file"
                      style={{ display: "none" }}
                      id="tag-image-upload"
                      onChange={handleImageUpload}
                    />
                    <Button
                      variant="outlined"
                      component="span"
                      startIcon={
                        <FileUploadOutlinedIcon sx={{ color: "#565E6D" }} />
                      }
                      size="small"
                      sx={{
                        borderColor: "#BCC1CA",
                        color: "#565E6D",
                        "&:hover": {
                          borderColor: "#565E6D",
                          backgroundColor: "#F3F4F6",
                        },
                      }}
                    >
                      Upload Image
                    </Button>
                  </label>
                  <Typography variant="caption" sx={{ color: "#565E6D" }}>
                    120x60px required
                  </Typography>
                </Box>
              </Grid>
            )}
          </Grid>
        </DialogContent>

        <DialogActions
          sx={{ padding: "16px 24px", borderTop: "1px solid #E5E7EB" }}
        >
          <Button
            onClick={() => setNewTagDialogOpen(false)}
            sx={{
              color: "#565E6D",
              border: "1px solid #BCC1CA",
              borderRadius: "0px",
              padding: "6px 16px",
              "&:hover": {
                backgroundColor: "#E5E7EB",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleCreateNewTag}
            disabled={!newTagData.product_tag}
            sx={{
              backgroundColor: "#565E6D",
              color: "#fff",
              borderRadius: "0px",
              padding: "6px 20px",
              "&:hover": {
                backgroundColor: "#424956",
              },
              "&:disabled": {
                backgroundColor: "#E5E7EB",
                color: "#9CA3AF",
              },
            }}
          >
            Create
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={open && !!selectedImage}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: {
            background: "#222",
            boxShadow: "0 8px 40px rgba(0,0,0,0.4)",
            borderRadius: "12px",
            overflow: "hidden",
            maxHeight: "90vh",
          }
        }}
      >
        <DialogContent 
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 0,
            background: "#222",
            minHeight: "60vh",
            maxHeight: "90vh",
          }}
        >
          {selectedImage ? (
            <img
              src={`https://www.ambikacc.com/product-profile-temp/medium-${selectedImage.split(",")[0].trim()}`}
              alt="Product Enlarged"
              style={{
                maxWidth: "100%",
                maxHeight: "90vh",
                objectFit: "contain",
                borderRadius: "8px",
                background: "#fff",
                margin: "auto",
                display: "block"
              }}
            />
          ) : null}
        </DialogContent>
      </Dialog>
    </Box>
  );
}
